import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker'
import { fetchGridLayout, getHyphenDDMMMYYYYHHMM, saveGridLayout } from '../common/utils';
import RoutemapTransitAction from './RoutemapTransitAction.js'
import RoutemapenrouteAction from './routemapenroute.js';
import CancelCourierConsignments from './cancellCourierConsignments.js';
// import UpdatePTLConsignments from './updateFTLConsignments.js';
import moment from "moment";
import { Modal } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import SweetAlert from "react-bootstrap-sweetalert";
import Filter from '../../assets/icons/filters.svg'
import redirectURL from "../redirectURL";
import MainCounters from './mainCounters.js'
import ViewMap from './ViewMap';
import TransitDelay from './TransitDelay';
import EnrouteException from './EnrouteException';
// import Overspeeding from './Overspeeding';
// import NightDriving from './NightDriving';
import LoadingException from './LoadingException';
import UnloadingException from './UnloadingException';
import DrawMap from '../common/drawmap';
import RoutemapAction from './routemapActionComponent.js';
import RouteNightDrivemap from './routenightdrivemap.js';
import NoGPS from './NoGPS.js';
import NoGPSMap from './NoGPSMap.js';
import ForceClose from './forceClose.jsx';
import CourierActions from '../layouts/courierActions.js';

import ConsignmentActions from './ConsignmentActionsComponent';
import ShipmentLegs from "../layouts/shipmentlegs.js";
import UpdatePTLConsignments from "./updatePTLConsignments.js";
import Datetime from "react-datetime";
import { outboundLink } from 'react-ga';





var map = ''
function PTLConsignments() {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    const user = useMemo(() => JSON.parse(decode(localStorage.getItem("k"))), []);

    const navigate = useNavigate();
    const agGridRef = useRef(null);
    const gridApi = useRef();
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    const reloadPage = useRef(false);
    var [rowData, setRowData] = useState([]);
    const [updatelrNo, setUpdateLrNo] = useState('');
    const [counterActive, setCounterActive] = useState("");
    var [filterToggle, setFilterToggle] = useState(false)
    var [key, setKey] = useState('')
    const [selectedRows, setSelectedRows] = useState([]);
    const [gridColumnState, setGridColumnState] = useState([]);
    const [overly, setOverlay] = useState("show-n")    
    var [deliveredSlide, setDeliveredSlide] = useState("");
    const [loadshow, setLoadShow] = useState("show-n")
    const [forcecloseModal, setForcecloseModal] = useState(false);
    const [cancelModal, setCloseCancelModal] = useState(false);
    const [counter, setCounter] = useState({ label: "PTL Consignments", value: "PTL consignments" });
    var [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    
    const [maptruckno, setMaptruckno] = useState('');
    const [deptcode, setDeptcode] = useState('');
    const [sliderRouteTranslate, setSliderRouteTranslate] = useState('');
    const [showDiv, setShowDiv] = useState('');
    const [mapinfo, setMapinfo] = useState({});
    const [dealer, setDealer] = useState('');
    const [consignment_code, setConsignment_code] = useState('');
    const [routeTruck, setRouteTruck] = useState({});
    const [leg_no, setLeg_no] = useState(0);
    const [tolls, setTolls] = useState([]);
    const [devation_flag, setDevation_flag] = useState(false);
    const [sliderCreateConsignmentTranslate, setSliderCreateConsignmentTranslate] = useState("show-n")
    var [selected_row, setselected_row] = useState({});
    var [Dselected_row, setDselected_row] = useState({});
    const [showAddForm, setshowAddForm] = useState("");
    const [showUpdateLrForm, setShowUpdateLrForm] = useState("");
    const [selectedInvoicetoUpdateLr, setSelectInvoicesToUpdate] = useState([])
    const [setLrUpdateBtn, setShowLrUpdateBtn] = useState(false);
    var [lrStatusList, setLrStatusList] = useState([
        { label: 'Booked', value: 'Booked' },
        { label: 'InTransit', value: 'InTransit' }, { label: 'Out For Delivery', value: 'Out For Delivery' },
        { label: 'Arrival At Destination', value: 'Arrival At Destination' }, { label: 'Delivered', value: 'Delivered' },
    ]);
    const [reasonForceClose, setReasonForceClose] = useState("");
    const [reasonForCancellation, setReasonForCancellation] = useState("")
    const [columnwithDefs, setColumnWithDefs] = useState([])
    const [filterCities, setFilterCities] = useState([]);
    const [filterStates, setFilterStates] = useState([]);
    const [filterTransporters, setFilterTransporters] = useState([]);
    const [filteredInvoices, setFilteredInvoices] = useState([]);
    const [filteredvehicles, setFilteredvehicles] = useState([]);
    const [lrNoOption, setLrOptions] = useState([]);
    const [filteredLrnos, setFilteredLrnos] = useState([]);
    const [searchCity, setSearchCity] = useState({ label: '', value: '' });
    const [searchState, setSearchStates] = useState({ label: '', value: '' });
    const [searchInvoice, setSearchInvoice] = useState({ label:"", value:"" });
    const [searchVehicle, setSearchVehicle] = useState({ value: "", label: "" })
    const [lrNo, setLrNo] = useState({ label:"", value:"" })
    const [searchTransporters, setSearchTransporters] = useState({ label: '', value: '' });
    const [searchConsigner, setSearchConsigner] = useState([{ label: 'All', value: 'all' }]);
    const [cancelledLrs, setCancelledLrs] = useState([])
    const [invoiceSelected, setInvoiceSelected] = useState([]);
    const [consignersList, setConsignersList] = useState([]);
    const [searchType, setSearchType] = useState({ label: "Invoice No", value: "invoice_no" });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [tabName, setTabName] = useState({ label: "In Active", value: "inactive" });
    var [filterToggle, setFilterToggle] = useState(false);
    var [tabActive, settabActive] = useState('ptl');
    const [searchValue, setSeachValue] = useState('');
    
    const [tabOptions, setTabOptions] = useState([
        { label: "Active", value: "active" },
        { label: "Completed", value: "completed" },
        { label: "All", value: "all" },
        { label: "In Active", value: "inactive" },
    ])

    const [manualUploadDetails, setmanualUploadDetails] = useState({
        lr_no: "",
          invoice_no: "",
        // consigner_name:"",
        // consignee_city:"",
        // consignee_pincode: "",
        // total_weight: ""
        //   lr_status: {'label':"","value":''},
        //     lr_status:'',
        //   location: "",
        //   arrival_time: "",
      });
      const [manualUploadDetails1, setmanualUploadDetails1] = useState({
        lr_no: "",
        invoice_no: selected_row.invoice_no || '',
        consigner_name: "",
        consignee_city: "",
        consignee_state: "",
        consignee_pincode: "",
        total_weight: ""
      });  

    const [formData, setFormData] = useState({
        truck_no: '',
        plant_code: '',
        plant_name: '',
        grno_consignment_code: '',
        invoice_no: '',
        driver_name: '',
        driver_mobile_num: '',
        mobile_operator: '',
        transit_days: '',
        consignee_code: '',
        consignee_name: '',
        invoice_date: '',
        gate_out_time: '',
        show: false,
        basicType: '',
        basicTitle: '',
        sliderCreateConsignmentTranslate: '',
        loadshow: 'show-n',
        overly: 'show-n',
    });
    const [counterOptions, setCounterOptions] = useState([
        { label: "Consignments", value: "consignments" },
        { label: "Transit Delays", value: "transit_delays" },
        { label: "No GPS Available", value: "no_gps_data" },
        { label: "No GPS Available Lifetime", value: "no_gps_data_lifetime" },
        // { label: "Overspeeding", value: "overspeeding" },
        // { label: "Night Driving", value: "night_driving" },
        { label: "Stoppages", value: "stoppages" },
        { label: "Accidents", value: "accidents" },
        { label: "Trip Deviations", value: "trip_deviations" },
        { label: "Loading Delay", value: "loading_delay" },
        { label: "Unloading Delay", value: "unloading_delay" }
    ]);
    const [ableRemark, setAbleRemark] = useState(false);
    var filterCardStyle1 = { minHeight: "234px" };
    var filterCardStyle2 = { padding: '10px' };
    var mnFilterClass = { marginLeft: "0px", padding: "0px" };
    const [rownode, setRownode] = useState([]);
    var [mapDetails, setMapDetails] = useState([]);
    const [activeTrips, setActiveTrips] = useState({
        all: [],
        picked_up: [],
        in_transit: [],
        out_for_delivery: [],
        tracking_na: [],
        transit_delay: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: []
    })
    const [completedTrips, setCompletedTrips] = useState({
        all: [],
        transit_delay: [],
        delivered: [],
        on_time: [],
        delayed: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: []
    })
    const [allTrips, setAllTrips] = useState({
        all: [],
        picked_up: [],
        in_transit: [],
        out_for_delivery: [],
        delivered: [],
        tracking_na: [],
        undelivered: [],
        cancelled: [],
        transit_delay: [],
        // overspeeding: [],
        // night_driving: [],
        stoppages: [],
        accidents: [],
        trip_deviations: [],
        loading_delay: [],
        unloading_delay: [],
        no_gps_data: [],
        no_gps_data_lifetime: []
    })
    const [inactiveTrips, setInactiveTrips] = useState({
        all: [],
        no_data: [],
        on_time: [],
        delayed: [],
        // transit_delay: [],
        // overspeeding: [],
        // night_driving: [],
        // stoppages: [],
        // accidents: [],
        // trip_deviations: [],
        // loading_delay: [],
        // unloading_delay: [],
        // no_gps_data: [],
        // no_gps_data_lifetime: []
    })
    const [modalloadData, setModalLoadData] = useState([])
    const [plantData, setPlantData] = useState([])
    const [transporters, setTransporters] = useState([])
    const [dealers, setDealers] = useState([])
    const [previousData, setPreviousData] = useState([])
    const fileRef = useRef()
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [loader, setLoader] = useState(false)
    const [bulkUploadModal, setBulkUploadModal] = useState({
        overly: "show-n",
        bulkPrioritySlide: ""
    })
    const [showAddForm2, setshowAddForm2] = useState("");
    const [form2Details, setForm2Details] = useState({
        event_status: [
          { label: 'InTransit', value: 'InTransit' }, 
          { label: 'Near Destination', value: 'near_destination' },
          { label: 'Reached Destination', value: 'reached_destination' },
          { label: 'Delivered', value: 'delivered' },
          { label: 'UnDelivered', value: 'Undelivered' },
        ],
        selectedStatus: { label: 'InTransit', value: 'InTransit' }, // Add a new state variable to store the selected status
        event_location: "",
        remark: "",
        delivered_date:'',
    })
    const [openMap, setOpenMap] = useState({
        sliderRouteTranslate: "",
        showDiv: 'show-n',
        mapinfo: [],
        dealer: "",
        consignment_code: "",
        maptruckno: "",
        geofence_coordinates: [],
        parking_coordinates: [],
        routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
        loadshow: 'show-n',
        sidebarSubHeader: "",
        overly: 'show-m',
        rownode: {},
        leg_no: 0,
        tolls: []
    })
    const [countersActive, setCountersActive] = useState({
        consignments: 0,
        picked_up: 0,
        in_transit: 0,
        out_for_delivery: 0,
        tracking_na: 0,
        undelivered: 0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0
    })
    const [countersCompleted, setCountersCompleted] = useState({
        consignments: 0,
        delivered: 0,
        on_time: 0,
        delayed:0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0
    })
    const [countersAll, setCountersAll] = useState({
        consignments: 0,
        picked_up: 0,
        in_transit:0,
        out_for_delivery: 0,
        delivered: 0,
        tracking_na: 0,
        undelivered: 0,
        cancelled: 0,
        transit_delays: 0,
        // overspeeding: 0,
        // night_driving: 0,
        stoppages: 0,
        accidents: 0,
        trip_deviations: 0,
        loading_delay: 0,
        unloading_delay: 0,
        no_gps_data: 0,
        no_gps_data_lifetime: 0
    })
    const [countersInactive, setCountersInactive] = useState({
        consignments: 0,
        delayed: 0,
        on_time: 0,
        no_data: 0
    })
    const transitdelaycols = [
        {
            headerName: "", field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapTransitAction,
                            params: {
                                onShowTransitRouteMap: onShowTransitRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Leg Start Time", field: "leg_start", width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_start);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Leg End Time", field: "leg_end_eta",
            width: 120, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.leg_end_eta);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }
            }
        },
        {
            headerName: "Exp. Leg Distance (KM)",
            field: "leg_expected_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                return Math.round(params.data.leg_expected_distance);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Actual Leg Distance Covered (KM)",
            field: "actual_leg_distance", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_leg_distance != '' && params.data.actual_leg_distance != undefined) {
                    return Math.round(params.data.actual_leg_distance);
                }
                else {
                    return 0;
                }
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exp. Distance from Trip Start(KM)",
            field: "expected_distance_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.expected_distance_start_to_leg != '' && params.data.expected_distance_start_to_leg != undefined) {
                    return Math.round(params.data.expected_distance_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }

        },
        {
            headerName: "Actual Distance from Trip Start (KM)",
            field: "actual_distance_traveled_start_to_leg", width: 140, resizable: true,
            valueGetter: function (params) {
                if (params.data.actual_distance_traveled_start_to_leg != '' && params.data.actual_distance_traveled_start_to_leg != undefined) {
                    return Math.round(params.data.actual_distance_traveled_start_to_leg);
                }
                else {
                    return 0;
                }

            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },

        {
            headerName: "Google Distance from Start (KM)",
            field: "actual_start_to_leg_google_distance",
            width: 140,
            resizable: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },
        {
            headerName: "GPS Data Available",
            field: "no_gps_data",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.no_gps_data == 1) {
                    return "Not Available";
                }
                if (params.data.no_gps_data == 0) {
                    return "Available";
                }

            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }


        },


        {
            headerName: "Trip Completed",
            field: "trip_completed",
            width: 140,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.trip_completed == 1) {
                    return "Yes";
                }
                if (params.data.trip_completed == 2) {
                    return "";
                }
                if (params.data.trip_completed == 0) {
                    return "";
                }

            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const stoppagescols = [
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapenrouteAction,
                            params: {
                                onShowEnrouteRouteMap: onShowEnrouteRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true,
        },
        {
            headerName: "Break Start",
            field: "stoppage_start_time",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.stoppage_start_time != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.stoppage_start_time)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break End",
            field: "reset_datetime",
            width: 150,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.reset_datetime != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.reset_datetime)
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Exception Closed On",
            field: "modified_date",
            width: 220,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.exception_closed == 1) {

                    if (params.data.modified_date != undefined) {
                        return getHyphenDDMMMYYYYHHMM(params.data.modified_date)
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Break Time",
            field: "elaped_time_from_last_moved_seconds",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.exception_closed == 1) {
                    var sdate = moment.parseZone(params.data.stoppage_start_time).format("x");
                    if (typeof params.data.reset_datetime == 'undefined') {
                        var edate = moment.parseZone().format("x");
                    }
                    else {
                        var edate = moment.parseZone(params.data.reset_datetime).format("x");
                    }
                    var diff = (edate - sdate) / 1000;
                    return secondsToString(diff);
                }
                else {
                    return '';
                }
            }
        }
    ]
    const overspeedcols = [
        {
            headerName: "", field: "_id",
            width: 50,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RoutemapAction,
                            params: {
                                onShowRouteMap: onShowRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            resizable: true
        },
        { headerName: "Truck No", field: "truck_no", filter: true, resizable: true },
        { headerName: "Speed (km/h)", field: "speed", filter: true, resizable: true },
        {
            headerName: "Reported At", field: "first_instance", filter: true, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.first_instance);
            }
        },
    ]
    const nightdrivingcols = [
        {
            headerName: "", field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: RouteNightDrivemap,
                            params: {
                                onShowNightDriveRouteMap: onShowNightDriveRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true
        },
        { headerName: "Truck No", field: "truck_no", width: 150, resizable: true },
        {
            headerName: "Traveled From", field: "first_instance", width: 180, resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.first_instance);
            }
        },
        {
            headerName: "Traveled Until", field: "recent_instance", resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.recent_instance);
            }
        },
        {
            headerName: "Distance Traveled (km)", field: "distance_from_first_instance", width: 180,
            resizable: true,
            valueGetter: function (params) {
                return Math.round(params.data.distance_from_first_instance)
            }
        }
    ]
    const unloadingcols = [
        {
            headerName: "From Date",
            field: "from_date",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                // console.log("child params ", params)
                if (params.data.from_date != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.from_date);
                }
                else {
                    return "NA"
                }

            }
        },
        {
            headerName: "To Date",
            field: "to_date",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                if (params.data.to_date != undefined) {
                    return getHyphenDDMMMYYYYHHMM(params.data.to_date);
                }
                else {
                    return "NA"
                }
            }
        },
        {
            headerName: "Unloading Time",
            field: "unloading_time",
            width: 180,
        }
    ]
    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        pivot: false,
    }
    let gridLegColumns = [];
    
    const columnDef = [
        
        {
            headerName: "LR No" ,
            field: "lr_no",
            width: 150,
            cellRenderer: '', resizable: true,
        },
        {
            headerName: "Invoice No" ,
            field: "invoice_no",
            width: 150,
            cellRenderer: '', resizable: true,
        },
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            width: 180,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && 	params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
        },
        {
            headerName: "Entity" ,
            field: "entity",
            width: 150,
            cellRenderer: '', resizable: true,
        },

        {
            headerName: "Customer Name",
            field: "consigner_name",
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.consigner_name != "" && params.data.consigner_name != "") {
                    return params.data.consigner_name
                }
            }
        },
        {
            headerName: "Destination State" ,
            field: "consignee_state",
            width: 150,
            cellRenderer: '', resizable: true,
        },
        {
            headerName: "Destination Pincode" ,
            field: "consignee_pincode",
            width: 180,
            cellRenderer: '', resizable: true,
        },
        {
            headerName: "Total CBM" ,
            field: "total_cbm",
            width: 150,
            cellRenderer: '', resizable: true,
        },
        {
            headerName: "Total Weight" ,
            field: "total_weight",
            width: 150,
            cellRenderer: '', resizable: true,
        },
        {
            headerName: "Courier Partner" ,
            field: "service_provider",
            width: 150,
            cellRenderer: '', resizable: true,
        },
        {
            headerName: "Vehicle Type" ,
            field: "vehicle_type",
            width: 150,
            cellRenderer: '', resizable: true,
        },
        {
            headerName: "Vehicle No" ,
            field: "truck_no",
            width: 150,
            cellRenderer: '', resizable: true,
        },
        {
            // headerName: "Trip Started On" ,
            headerName: "Dispatch Date" ,
            field: "dispatch_date",
            width: 150,
            //filter: "agDateColumnFilter",
            cellRenderer: '', resizable: true,
            comparator: dateComparator,

            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                console.log(params.data.dispatch_date,"DDDDDDFFFF");
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    // Call date formatting only when the dispatch date is valid
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    // Check if formattedDate is valid, otherwise return "NA"
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
        },
        {
            headerName: "Mode (Air/Road/Rail)",
            field: "shipment_mode",
            width: 190,
            cellRenderer: '',
            resizable: true,
        },
        {
            headerName: "E-Way Bill No",
            field: "eway_bill_no",
            width: 150,
            cellRenderer: '',
            resizable: true,
        },
        {
            headerName: "Number Of Boxes",
            field: "no_of_boxes",
            width: 150,
            cellRenderer: '',
            resizable: true,
        },
        {
            headerName: "Customer Mail ID",
            field: "customer_mail_id",
            width: 150,
            cellRenderer: '',
            resizable: true,
        }


        // {
        //     headerName: "Origin City" ,
        //     field: "consigner_city",
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        // },

        // {
        //     headerName: "Destination City" ,
        //     field: "consignee_city",
        //     width: 150,
        //     cellRenderer: '', resizable: true,
        // },
        // {
        //     headerName: "Invoice No." ,
        //     field: "invoice_no",
        //     width: 150,
        //                 pinned: "left",
        //     cellRenderer: '', resizable: true,
        // },
        
        // {
        //     headerName: "Invoice Type" ,
        //     field: "invoice_type",
        //     width: 150,
        //                 pinned: "left",
        //     cellRenderer: '', resizable: true,
        // },
        // {
        //     headerName: "Transporter",
        //     field: "transporter_name",
        //     width: 180,
        //     filter: "agSetColumnFilter",
        //     cellRenderer: '',
        //     resizable: true,
        //     valueGetter: function (params) {
        //         if (params.data.truck_no != "" && params.data.truck_no != "") {
        //             return params.data.transporter_name
        //         }
        //     }
        // },

        // {
        //     headerName: "ODA",
        //     field: "origin_destination_area",
        //     width: 150,
        //     cellRenderer: '',
        //     resizable: true,
        // },
    ]
    const nogpscols = [
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPSMap,
                            params: {
                                onShowNoGPSRouteMap: onShowNoGPSRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Truck No", field: "truck_no", width: 100, resizable: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Last Data Receieved",
            field: "last_packet_datetime",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.last_packet_datetime);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Data Received on",
            field: "packet_received_on",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.packet_received_on);
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const columnDefs2 = [
        {
            headerName: "",
            field: "_id",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: ViewMap,
                            params: {
                                onClickShowRoute: onClickShowRoute
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "transit_delay",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: TransitDelay,
                            params: {
                                onShowTransitData: onShowTransitData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "no_gps_data",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPS,
                            params: {
                                onShowNoGPSData: onShowNoGPSData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "enroute_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: EnrouteException,
                            params: {
                                onShowStoppagesData: onShowStoppagesData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        // {
        //     headerName: "",
        //     field: "overspeeding_exception",
        //     width: 50,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: Overspeeding,
        //                     params: {
        //                         onShowOverspeedingData: onShowOverspeedingData
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        // {
        //     headerName: "",
        //     field: "nightdriving_exception",
        //     width: 50,
        //     pinned: "left",
        //     cellRendererSelector: function (param) {
        //         try {
        //             if (param.data._id != null && param.data._id != undefined) {
        //                 return {
        //                     component: NightDriving,
        //                     params: {
        //                         onShowNightDrivingData: onShowNightDrivingData
        //                     }
        //                 }
        //             }
        //         } catch (err) {
        //             console.log(err);
        //         }
        //     },
        //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        // },
        {
            headerName: "",
            field: "loading_delay_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: LoadingException,
                            params: {
                                onShowLoadingData: onShowLoadingData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "unloading_delay_exception",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: UnloadingException,
                            params: {
                                onShowUnloadingData: onShowUnloadingData
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "Consignment Code",
            field: "consignment_code"
        },
        {
            headerName: "Status",
            field: "status",
            valueGetter: function (params) {
                if (params.data.status == 1) {
                    return "Open";
                }
                else if (params.data.status == 2) {
                    return "InTransit";
                }
                else if (params.data.status == 3) {
                    return "Near Dealer";
                }
                else if (params.data.status == 4) {
                    return "Reached Dealer";
                }
                else if (params.data.status == 5) {
                    return "Left Dealer";
                }
                else if (params.data.status == 6) {
                    return "Force Closed";
                }
                else if (params.data.status == 7) {
                    return "Proximity Trip Closure";
                }
                else if (params.data.status == 8) {
                    return "Force Closed";
                }
                else {
                    return "NA";
                }
            }
        },
        {
            headerName: "Plant Location Code",
            field: "consigner_code"
        },
        {
            headerName: "FO Number",
            field: "fo_number"
        },
        {
            headerName: "Order Number",
            field: "order_number"
        },
        {
            headerName: "Quantity",
            field: "quantity"
        },
        {
            headerName: "Gross Weight (VU)",
            field: "gross_weight"
        },
        {
            headerName: "Gross Volume (VU)",
            field: "gross_volume"
        },
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            valueGetter: function (params) {
                if (params.data.invoice_time != undefined && params.data.invoice_time != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time)
                }
            }
        },
        {
            headerName: "Vehicle No.",
            field: "truck_no"
        },
        {
            headerName: "Vehicle Type",
            field: "truck_type"
        },
        {
            headerName: "Gate In Time",
            field: "gate_in_time"
        },
        {
            headerName: "Transporter Code",
            field: "transporter_code"
        },
        {
            headerName: "Transporter Name",
            field: "transporter_name"
        },
        {
            headerName: "Consigner Code",
            field: "consigner_code"
        },
        {
            headerName: "Consignee Code",
            field: "consignee_code"
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name"
        },
        {
            headerName: "Consignee Zone",
            field: "consignee_zone"
        },
        {
            headerName: "Consignee Area",
            field: "consignee_area"
        },
        {
            headerName: "Consignee City",
            field: "consignee_city"
        },
        {
            headerName: "Consignee State",
            field: "consignee_state"
        },
        {
            headerName: "Dealer Distance from Plant",
            field: "dealer_distance_from_plant"
        },
        {
            headerName: "Execution Date",
            field: "execution_date",
            valueGetter: function (params) {
                if (params.data.execution_date != undefined && params.data.execution_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.execution_date)
                }
            }
        },
        {
            headerName: "Expected Delivery Date",
            field: "expected_date",
            valueGetter: function (params) {
                if (params.data.expected_date != undefined && params.data.expected_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_date)
                }
            }
        },
        {
            headerName: "Expected Return To Plant Date",
            field: "expected_return_to_plant_date",
            valueGetter: function (params) {
                if (params.data.expected_return_to_plant_date != undefined && params.data.expected_return_to_plant_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.expected_return_to_plant_date)
                }
            }
        },
        {
            headerName: "Created Date",
            field: "created_date",
            valueGetter: function (params) {
                if (params.data.created_date != undefined && params.data.created_date != '') {
                    return getHyphenDDMMMYYYYHHMM(params.data.created_date)
                }
            }
        },
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: ForceClose,
                            params: {
                                onShowForceCloseModal: onShowForceCloseModal
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        }
    ];
    const isDelivered = window.location.pathname.includes("completedconsignments")
    // let showdistance = (this.props.match.path == "/activecosnignments")
			// || (this.props.match.path == "/prtconsignments")
			// || (this.props.match.path == "/tnpconsignments")) 
            // ? false : true;
    
    useEffect(()=>{
        if(form2Details.selectedStatus.value === "Undelivered"){
            setAbleRemark(true)
        } else {
            setAbleRemark(false)
        }
    }, [form2Details.selectedStatus])
    var x = [{
        headerName: "Check",
        field: "_id",
        hide: (tabName.value !== "inactive"),
        colId: "_id",
        width: 40,
        pinned: 'left',
        filter: false, 
        resizable: true,
        checkboxSelection: true
    }]
    var y = [
        {
            headerName: "Order Withdrawel",
            field: "cancel_order",
            width: 140,
            pinned: 'left',
            hide: (tabName.value !== 'active' && tabName.value !=="inactive"),
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: CancelCourierConsignments,
                            params: {
                                onClickActive: onClickCancelActiveCourierConsignemnts
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        },
    ]
    let actionAbleDefs = [ 
        
        ...x,      
        {
            headerName: "",
            field: "_id",
            width: 50,
            pinned: "left",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: CourierActions,
                            params: {
                                onShowCourierTrack: onShowCourierTrack
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        ...y,
        {
            headerName: "Update",
            field: "update",
            width: 80,
            pinned: "left",
            hide: tabName.value !== 'active',
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        console.log(param.data,'MMMMMMMMMMMMMMMMM', tabName.value);
                        if(tabName.value === "active"){
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: onClickActive
                                }
                            };                            
                        } else {
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive: onClickActive
                                }
                            };
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        },
        {
            headerName: "Update Delivery Status",
            field: "update",
            width: 190,
            pinned: "left",
            hide: (tabName.value !== 'active' && tabName.value !=="inactive"),
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        console.log(param.data,'MMMMMMMMMMMMMMMMM', tabName.value);
                        if(param.data.manual_tracking === 1){                                
                            return {
                                component: UpdatePTLConsignments,
                                params: {
                                    onClickActive:updateDeliveredDate
                                }
                            }
                        } else {
                            return null;
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        },
        {
            headerName: "Update LR",
            field: "update",
            width: 100,
            pinned: "left",
            hide: tabName.value !== 'inactive',
            cellRendererSelector: function (param) {
                try {
                    console.log(param,"Paaaaaaaaaaaaaaaaaaaaaaaaa");
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: UpdatePTLConsignments,
                            params: {
                                onClickActive: onClickActive
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
        },
    ]
    var intransitColDefs =
			[
                {
					headerName: "Vehicle No" ,
					field: "truck_no",
                    hide: (tabName.value === "inactive"),
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "LR No." ,
					field: "lr_no",
                    hide: (tabName.value === "inactive"),
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Invoice No" ,
					field: "invoice_no",
					width: 150,
					cellRenderer: '', resizable: true,
				},  
				{
					headerName: "Status",
					field: "consignment_status",
					width: 120,
					// hide : hideStatus,
					filter: "agSetColumnFilter",
					resizable: true,
                    // valueFormatter: (params) => {
                    //     const statusMap = {
                    //         1: "At Plant",
                    //         2: "In Transit",
                    //         3: "Near Destination",
                    //         4: "Reached Dealer",
                    //         5: "Left Dealer",
                    //         6: "Force Closure",
                    //         7: "Provision"
                    //     };
                    //     return statusMap[params.value] || "Not Available";
                    // }
					// valueGetter: (params) => {
					// 	//console.log("GPS ", params.data.gps_data_available);
					// 	if (params.data.status == 1) {
					// 		return "Inside Plant"
					// 	}
					// 	else if (params.data.status == 2) {
					// 		return "In Transit"
					// 	}
					// 	else if (params.data.dest_geofence_id != undefined && screen_type == "LOG-PRT") {
					// 		if (screen_url != "/prtconsignments") {
					// 			return "Reached Plant Gate";
					// 		}
					// 	}
					// 	else if (params.data.status == 3) {
					// 		return "Near Destination"
					// 	}
					// 	else if (params.data.status == 4) {
					// 		return "Reached Destination"
					// 	}

					// 	else if (params.data.status == 5) {
					// 		return "Trip Completed"
					// 	}
					// 	else if (params.data.status == 6) {
					// 		return "Force Closed"
					// 	}
					// 	else if (params.data.status == 7) {
					// 		return "Proximity Trip Closure"
					// 	}
					// 	else if (params.data.status == 8) {
					// 		return "Crossdock"
					// 	}
					// 	else if (params.data.status == 9) {
					// 		return "Trip Completed"
					// 	}
					// 	else {
					// 		return ""
					// 	}

					// }
				},
				{
					headerName: "Invoice Date",
					field: "invoice_time",
					width: 180,
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,

					valueGetter: function (params) {
                        console.log(params,"Khaleja");
						if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
							return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
						}
						else {
							return "NA";
						}
					},
					// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : hideonlyPRT, // this logic was imported from msil so for hero we are commenting this as of 27-07-2022
				},
                {
					headerName: "Dispatch Date" ,
					field: "dispatch_date",
					width: 150,
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,

					valueGetter: function (params) {
                        const dispatchDate = params.data.dispatch_date;
                        console.log(params.data.dispatch_date,"DDDDDDFFFF");
                        if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                            // Call date formatting only when the dispatch date is valid
                            const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                            // Check if formattedDate is valid, otherwise return "NA"
                            return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                        } else {
                            return "NA";
                        }
                    },
				},
				{
					headerName: "Customer Name",
					field: "consigner_name",
					width: 180,
					filter: "agSetColumnFilter",
					cellRenderer: '',
					resizable: true,
					valueGetter: function (params) {
						if (params.data.consigner_name != "" && params.data.consigner_name != "") {
							return params.data.consigner_name
						}
					}
				},
                {
					headerName: "Entity" ,
					field: "entity",
					width: 150,
					cellRenderer: '', resizable: true,
				},               
                {
					headerName: "Invoice Type" ,
					field: "invoice_type",
					width: 150,
					cellRenderer: '', resizable: true,
				},
				{
					headerName: "Transporter",
					field: "transporter_name",
					width: 180,
					filter: "agSetColumnFilter",
					cellRenderer: '',
					resizable: true,
					valueGetter: function (params) {
						if (params.data.truck_no != "" && params.data.truck_no != "") {
							return params.data.transporter_name
						}
					}
				},
                {
					headerName: "Source City" ,
					field: "consigner_city",
					width: 150,
					cellRenderer: '', resizable: true,
				},  
                {
					headerName: "Source Pincode" ,
					field: "consigner_pincode",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Source Zone" ,
					field: "consigner_zone",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Destination City" ,
					field: "consignee_city",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Destination Pincode" ,
					field: "consignee_pincode",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Destination State" ,
					field: "consignee_state",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Total Weight" ,
					field: "total_weight",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Total CBM" ,
					field: "total_cbm",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Transporter Category" ,
					field: "source_from",
					width: 190,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Vehicle Type" ,
					field: "vehicle_type",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Truck Seal No" ,
                    hide: (tabName.value === "inactive"),
					field: "truck_seal_no",
					width: 150,
					cellRenderer: '', resizable: true,
				},
                {
                    headerName: "ODA",
                    field: "origin_destination_area",
                    width: 150,
                    cellRenderer: '',
                    resizable: true,
                }, 
                {
					headerName: "POD Status" ,
					field: "pod_status",
                    hide: (tabName.value === "inactive"),
					width: 150,
					cellRenderer: '', resizable: true,
				}, 
                {
					headerName: "TAT" ,
					field: "tat",
                    hide: (tabName.value === "inactive"),
					width: 150,
					cellRenderer: '', resizable: true,
				},
				{
					headerName: "Last Data Recieved On",
					field: "last_process_on",
					width: 180,
                    hide:(tabName.value !== "completed" && tabName.value !== "all"),
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,

					valueGetter: function (params) {
						if (params.data.last_process_on != '' && params.data.last_process_on != undefined && params.data.last_process_on !== ' ') {
							return getHyphenDDMMMYYYYHHMM(params.data.last_process_on);
						}
						else {
							return "NA";
						}
					},
				},  
                {
					headerName: "Expected ETA" , // estimated delivery data
					field: "expected_eta",
					width: 150,
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,
                    hide: (tabName.value === "inactive"),
					valueGetter: function (params) {
                        const expectedEta = params.data.expected_eta;
                        const tripEndMaster = params.data.expected_trip_end_master;
                
                        if (expectedEta && expectedEta.trim() !== '') {
                            return getHyphenDDMMMYYYYHHMM(expectedEta);
                        } else if (tripEndMaster && tripEndMaster.trim() !== '') {
                            return getHyphenDDMMMYYYYHHMM(tripEndMaster);
                        } else {
                            return "NA";
                        }
                    },
				
				},
                // akhila
				{
					headerName: "Revised Estimated Delivery Date",
					field: "modified_date",
					width: 240,
                    hide: (tabName.value === "inactive"),
					cellRenderer: '', resizable: true,
					comparator: dateComparator,
					valueGetter: function (params) {
						if (params.data.modified_date != '' && params.data.modified_date != undefined && params.data.modified_date !== ' ') {
							return getHyphenDDMMMYYYYHHMM(params.data.modified_date);
						}
						else {
							return "NA";
						}
					},
				},
                {
					headerName: "Actual Delivery Date",
					field: "delivery_datetime",
					width: 180,
                    hide: (tabName.value === "inactive"),
					cellRenderer: '', resizable: true,
					comparator: dateComparator,
					valueGetter: function (params) {
						if (params.data.delivery_datetime != '' && params.data.delivery_datetime != undefined && params.data.delivery_datetime !== ' ') {
							return getHyphenDDMMMYYYYHHMM(params.data.delivery_datetime);
						}
						else {
							return "NA";
						}
					},
				},
                {
					headerName: "Perfomance" ,
					field: "delivery_performance",
					width: 180,
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Delay Days" ,
					field: "transit_delay_hours",
					width: 180,
                    hide: (tabName.value !== 'completed' && tabName.value !== "all"),
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Delay Days Bucket" ,
					field: "delay_days_bucket",
					width: 180,
                    hide: (tabName.value !== 'completed' && tabName.value !== "all"),
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "Transit Delay Reason" ,
					field: "delay_reason",
					width: 180,
                    hide: (tabName.value !== 'completed' && tabName.value !== "all"),
					cellRenderer: '', resizable: true,
				},
                {
					headerName: "EWB No" ,
					field: "ewb_no",
					width: 150,
					cellRenderer: '', resizable: true,
				}, 
                {
					headerName: "Mode" ,
					field: "shipment_mode",
					width: 150,
					cellRenderer: '', resizable: true,
				},   
                {
					headerName: "Fuel Type" ,
					field: "fuel_type",
					width: 150,
					cellRenderer: '', resizable: true,
				},
				{
					headerName: "Disabled Time",
					field: "cancelled_time",
                    hide: (tabName.value === "inactive" && tabName.value === "inactive"),
					width: 180,
					//filter: "agDateColumnFilter",
					cellRenderer: '', resizable: true,
					comparator: dateComparator,

					valueGetter: function (params) {
						if (params.data.cancelled_time != '' && params.data.cancelled_time != undefined && params.data.cancelled_time !== ' ') {
							return getHyphenDDMMMYYYYHHMM(params.data.cancelled_time);
						}
						else {
							return "NA";
						}
					},
					// hide: (this.state.tnpReturnConsignmentsVisibilty) ? true : hideonlyPRT, // this logic was imported from msil so for hero we are commenting this as of 27-07-2022
				},
                {
					headerName: "Boxes" ,
					field: "no_of_boxes",
					width: 150,
					cellRenderer: '', resizable: true,
				},
				
                // {
                //     headerName: "",
                //     field: "view_route",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data.view_route != null && param.data.view_route != undefined) {
                //                 return {
                //                     component: ViewMap,
                //                     params: {
                //                         onClickShowRoute: onClickShowRoute
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "Transit Delay",
                //     field: "transit_delay",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: TransitDelay,
                //                     params: {
                //                         onShowTransitData: onShowTransitData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "GPS Data",
                //     field: "no_gps_data",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: NoGPS,
                //                     params: {
                //                         onShowNoGPSData: onShowNoGPSData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "Enroute Stoppages",
                //     field: "enroute_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: EnrouteException,
                //                     params: {
                //                         onShowStoppagesData: onShowStoppagesData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "",
                //     field: "loading_delay_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: LoadingException,
                //                     params: {
                //                         onShowLoadingData: onShowLoadingData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
                //     headerName: "",
                //     field: "unloading_delay_exception",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: UnloadingException,
                //                     params: {
                //                         onShowUnloadingData: onShowUnloadingData
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
                // {
				// 	pinned: "left",
				// 	headerName: 'Deviation',
				// 	colId: 'deviation_identified',
				// 	field: 'deviation_identified',
				// 	width: 40,
				// 	cellStyle: { color: "#464855", fontWeight: "500", display: "flex", alignItems: "center" },
				// 	// cellRenderer: 'kpiDeviationActions',
				// 	// valueGetter: function (params) {
				// 	// 	if(params.data.deviation_identified != undefined && params.data.deviation_identified != null && params.data.deviation_identified != ""){
				// 	// 		if ([1,1.0,"1","1.0"].includes(params.data.deviation_identified))
				// 	// 		{
				// 	// 		   return "Deviated";
				// 	// 	   }
				// 	// 	   else {
				// 	// 		   return "Not Deviated";
				// 	// 	   }
				// 	// 	}else{
				// 	// 		return "Not Deviated";
				// 	// 	}
				// 	// }
				// },
                // {
                //     headerName: "Shipment Legs",
                //     field: "shipmentlegs",
                //     width: 50,
                //     pinned: "left",
                //     cellRendererSelector: function (param) {
                //         try {
                //             if (param.data._id != null && param.data._id != undefined) {
                //                 return {
                //                     component: ShipmentLegs,
                //                     params: {
                //                         onClickShowShipmentLegs: onClickShowShipmentLegs
                //                     }
                //                 }
                //             }
                //         } catch (err) {
                //             console.log(err);
                //         }
                //     },
                //     cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
                // },
				// {
				// 	headerName: "View Route",
				// 	field: "_id",
				// 	colId: "_id",
				// 	width: 40,
				// 	pinned: 'left',
				// 	cellRenderer: ConsignmentActions,
				// 	filter: false, resizable: true

				// },
	];
    var deliveredColDefs = [...intransitColDefs];

    

    deliveredColDefs.splice(16, 0, {
        headerName: "Recent Destination",
        field: "last_location",
        width: 150,
        cellRenderer: '',
        resizable: true,
    });

    deliveredColDefs.push({
        headerName: "Delivery Station",
        field: "delivery_station",
        width: 150,
        cellRenderer: '',
        resizable: true,
    });

    var allColDefs = [...deliveredColDefs];
    var inactiveColDefs = [];
    
    useEffect(() => {
        if ( tabName.value == "active" ) {
            setRowData(activeTrips.all);
            setColumnWithDefs([...actionAbleDefs,...intransitColDefs]);            
        } else if (tabName.value == "completed") {
            setRowData(completedTrips.all)
            setColumnWithDefs([...actionAbleDefs, ...deliveredColDefs]);
        }
        else if (tabName.value == "all") {
            setRowData(allTrips.all);
            setColumnWithDefs([...actionAbleDefs, ...allColDefs]);
        } else {
            setColumnWithDefs([...actionAbleDefs, ...intransitColDefs]);
            setRowData(inactiveTrips.all)
        }
       
    }, [tabName.value])

    // update button visible
    useEffect(()=>{
        setShowLrUpdateBtn(true)
    }, [selectedRows])
    // open slider
    const updateLrs = () => {
        setShowUpdateLrForm('slider-translate-30p');
        setOverlay('show-m');        
        const x = selectedRows.map((e)=> ({label:e.invoice_no, value: e.invoice_no}))
        console.log(x,"selectedInvoices");
        
        setSelectInvoicesToUpdate(x);
    }
    
    // deselect all rows
    const deselectAllRows = () => {
        if (agGridRef.current && agGridRef.current.api) {
            agGridRef.current.api.deselectAll();
        }
    };

    //  hide the slider
    const onClickHideLrUpdateForm = () => {
        setShowUpdateLrForm("");
        setOverlay("show-n");
        setSelectedRows([]);
        setSelectInvoicesToUpdate([]);
        deselectAllRows();
        setShowLrUpdateBtn(false);
        setUpdateLrNo("")
    }
    const cancelUpdateLrNo = () => {
        setShowUpdateLrForm("");
        setOverlay("show-n");
        setSelectedRows([]);
        setSelectInvoicesToUpdate([]);
        deselectAllRows();
        setShowLrUpdateBtn(false);
        setUpdateLrNo("")
    }
    const onClickActive = (e) => {
        console.log(e,"adddeal")
        setselected_row(e.data);
        setmanualUploadDetails1((prev) => ({
                ...prev,
                invoice_no: e.data.invoice_no,
                consigner_name: e.data.consigner_name,
                consignee_city: e.data.consignee_city,
                consignee_state: e.data.consignee_state,
                consignee_pincode: e.data.consignee_pincode,
                total_weight: e.data.total_weight
            }
        ))
        setmanualUploadDetails((prev) => (
            {
                ...prev,
                invoice_no: e.data.invoice_no,
            lr_no: e.data.lr_no}
        ))
        setshowAddForm("slider-translate-30p");
        setOverlay("show-m");
    }
    const updateDeliveredDate = (e) => {
        console.log(e,"adddeal")
        setDselected_row(e.data);        
        setshowAddForm2("slider-translate-30p");
        setOverlay("show-m");
      };
    const resetFilters = () => {
        setSeachValue("");
        setLrNo({value:"", label:""});
        setSearchInvoice({value: "", label:""});
        setSearchVehicle({ value:"", label:"" });
        loadConsignmentsData()
    }
    const resetFilters1 = () => {
        setSearchConsigner([{ label: 'All', value: 'all' }]);
        setSearchTransporters({value: "", label: ""});
        setSearchStates({value: "", label: ""});
        setSearchCity({value:"", label: ""});
        setStartDate('');
        setEndDate('');
        loadConsignmentsData()
    }
    const onGetConsignments = (event) => {
        let query = {}
        if (searchCity.value != '')
            query["consignee_city"] = searchCity.value
        if (startDate == '' || startDate == "NaN-NaN-NaN") {
            var sDate = "";
        }
        else {
            query["sdate"] = startDate
        }
        if (endDate == '' || startDate == "NaN-NaN-NaN") {
            var eDate = "";
        }
        else {
            query["edate"] = endDate
        }
        if (searchConsigner == null || searchConsigner[0]?.value == '' || searchConsigner[0]?.value == 'all') {
        }
        else {
            query["consigner_code"] = searchConsigner.map(e => e.value)
        }
        if (searchState.value != '') {
            query["consignee_state"] = searchState.value
        }
        if (searchTransporters.value != "") {
            query["transporter_name"] = searchTransporters.value
        }
        redirectURL.post("consignments/filterCourierLRConsignments", query)
            .then(resp => {                
                fragmentData(resp.data.consignments)
            })
            .catch(err => console.log(err))
    }
    const onClickHideAll = () => {
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: [],
        })
        setDselected_row({})
        setshowAddForm2("")
        setForm2Details({
            event_status: [
              { label: 'InTransit', value: 'InTransit' }, 
              { label: 'Near Destination', value: 'near_destination' },
              { label: 'Reached Destination', value: 'reached_destination' },
              { label: 'Delivered', value: 'delivered' },
              { label: 'UnDelivered', value: 'Undelivered' },
            ],
            selectedStatus: {value: 'InTransit', label: 'InTransit'},
            event_location: "",
            remark: "",
            delivered_date:'',
        })
        setshowAddForm("")
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setLoadShow("show-n")
        setSliderCreateConsignmentTranslate("");
        setShowUpdateLrForm("")
    }
    const saveConsignmentData = async (event) => {
        event.preventDefault();
        let specialCharcters = 0;
        const { truck_no, plant_code, grno_consignment_code, invoice_no, driver_name, driver_mobile_num, mobile_operator, transit_days, consignee_code, consignee_name } = formData;
        const invoice_date = document.getElementById('invoice_date').value;
        const created_by = localStorage.getItem('email');
        // const encode = cipher('V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x');
        let transporter_code = '';

        if (localStorage.getItem('user_type') === 'TRANSPORTER') {
            const tpt_code = JSON.parse(localStorage.getItem('transportercode'));
            transporter_code = tpt_code[0];
        } else {
            transporter_code = formData.transporter_code;
        }

        const gate_out_time = document.getElementById('gate_out_time').value;

        if (truck_no && truck_no.match(/[^a-zA-Z0-9]/g)) {
            specialCharcters = 1;
        }

        if (specialCharcters === 0) {
            let fieldsChk = 0;
            if (truck_no && plant_code && grno_consignment_code && invoice_no && invoice_date && gate_out_time && consignee_code) {
                fieldsChk = 1;
            }

            if (fieldsChk === 1) {
                const params = {
                    truck_no,
                    plant_code,
                    plant_name: formData.plant_name,
                    consignment_code: grno_consignment_code,
                    invoice_no,
                    invoice_date,
                    gate_out_time,
                    consignee_code,
                    consignee_name,
                    driver_name,
                    driver_mobile_number: driver_mobile_num,
                    sim_tracking_service_provider: parseInt(mobile_operator),
                    transit_days,
                    transporter_code,
                    created_by,
                };

                try {
                    const response = await redirectURL.post('/dashboard/saveConsignmentData', params);
                    if (response.data.status === 'success') {
                        document.getElementById('invoice_date').value = '';
                        document.getElementById('gate_out_time').value = '';
                        setFormData({
                            ...formData,
                            show: true,
                            basicType: 'success',
                            basicTitle: 'Successfully created consignment',
                            sliderCreateConsignmentTranslate: '',
                            truck_no: '',
                            plant_code: '',
                            plant_name: '',
                            grno_consignment_code: '',
                            invoice_no: '',
                            consignee_code: '',
                            consignee_name: '',
                            driver_name: '',
                            driver_mobile_num: '',
                            mobile_operator: '',
                            transporter_code: '',
                            loadshow: 'show-n',
                            overly: 'show-n',
                            transit_days: '',
                        });
                        // Call componentDidMount equivalent
                    } else {
                        setFormData({
                            ...formData,
                            show: true,
                            basicType: 'danger',
                            basicTitle: response.data.message === 'Consignment Code Already Exists' ? 'Consignment Code Already Exists' : 'Failed to create consignment',
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
            } else {
                setFormData({
                    ...formData,
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'All fields are mandatory',
                });
            }
        } else {
            setFormData({
                ...formData,
                show: true,
                basicType: 'danger',
                basicTitle: 'Special characters are not allowed',
            });
        }
    };

    const closeForceCloseModal = (e) => {
        setForcecloseModal(false)
        setReasonForceClose('')
        setRownode([])
    }
    const closeCancelModal = (e) => {
        setCloseCancelModal(false)
        setReasonForCancellation('')
        setRownode([])
    }
    const onShowForceCloseModal = (e) => {
        setForcecloseModal(true)
        setRownode(e)
        setReasonForceClose('')
    }
    
    const saveGrid = async (e) => {
        let coloumnState = columnApiConsignments.current.getColumnState()
        let temp = await saveGridLayout(user.email, "consignments", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const resetGrid = async (e) => {
        let coloumnState = []
        let temp = await saveGridLayout(user.email, "consignments", coloumnState)
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
            reloadPage.current = true
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }
    const onSelectionChanged = (params) => {
        const selectedNodes = params.api.getSelectedNodes();
        const selectedData = selectedNodes.map(node => node.data);
        setSelectedRows(selectedData);
        console.log("Selected Rows:", selectedData);
    };
    const formForceCloseHandler = (e) => {
        e.preventDefault()
        var consignemnt = rownode;
        var consignment_code = consignemnt.consignment_code;
        var truck_no = consignemnt.truck_no;
        var dept_code = "SNDG";
        var email = user?.email;
        var reqdata = {
            dept_code: dept_code,
            consignment_code: [consignment_code],
            truck_no: truck_no,
            email: email,
            reasonforceclose: reasonForceClose,
        }
        // console.log(activeTrips.in_transit,"before hitting");
        redirectURL.post("/consignments/updateConsignmentForceClose", reqdata)
            .then((response) => {
                if (response.data.status == 'Success') {
                    setShow(true)
                    setTitle("Successfully Force Closed the consignment")
                    setType("success")
                    closeForceCloseModal()
                    setRowData(activeTrips.in_transit)
                    reloadPage.current = true;
                }
                else {
                    setShow(true)
                    setTitle("Failed to Force Close")
                    setType("danger")
                }
            })
            .catch(function (e) {
                console.log("Error ", e)
            })

    }
    const cancelFormCloseHandler = (e) => {
        e.preventDefault();
        let invoices_list = lrNoOption.map((e)=> e.label)
        let reqData = {
            lrNo: rownode.lr_no,
            invoices_selected: invoices_list,
            reasonForCancellation: reasonForCancellation
        }
        console.log(reqData,"reqData");
        redirectURL.post("/consignments/updateConsignmentCancellation", reqData)
            .then(async (response) => {
                if (response.data.status == 'success') {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("success")
                    closeCancelModal();
                    setRownode([]);
                    setLrOptions([]);
                    setReasonForCancellation("");
                    window.location.reload();
                }
                else {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("danger")                    
                    closeCancelModal();
                }
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }
    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };
    // async onClickShowShipmentLegs(params) {
	// 	console.log("params", params)
	// 	if (params != 0) {
	// 		var transitedelaydata = [];

	// 		await this.setState({

	// 			detailCellRendererParams: {
	// 				suppressRefresh: true,
	// 				detailGridOptions: {
	// 					headerHeight: 50,
	// 					columnDefs: [
	// 						{
	// 							headerName: "",
	// 							field: "legs_map",
	// 							colId: "legs_map",
	// 							width: 40,
	// 							pinned: 'left',
	// 							cellRenderer:function(params){
	// 								var htmloption = '<i class="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
	// 								return htmloption;
	// 							} ,
	// 							filter: false, resizable: true
			
	// 						},
	// 						{
	// 							headerName: "Invoice No",
	// 							field: "invoice_no",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Consignment",
	// 							field: "consignment_code",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Original ETA",
	// 							field: "expected_trip_end",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
	// 							},
	// 							cellClass: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}
	// 							},

	// 						},
	// 						{
	// 							headerName: "Revised ETA",
	// 							field: "revised_trip_end",
	// 							width: 140,
	// 							valueGetter: function (params) {
	// 								return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
	// 							},
	// 							cellClass: function (params) {
	// 								if (params.data.transit_delay == 1) {
	// 									return 'lightred';
	// 								}
	// 								else {
	// 									return '';
	// 								}

	// 							}
	// 						},
							
	// 						{
	// 							headerName: "Status",
	// 							field: "status",
	// 							width: 140,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// },
								

	// 							valueGetter: function (params) {
	// 								//console.log("GPS ", params.data.gps_data_available);
	// 								if (params.data.status == 1) {
	// 									return "Inside Plant"
	// 								}
	// 								else if (params.data.status == 2) {
	// 									return "In Transit"
	// 								}
	// 								else if (params.data.status == 3) {
	// 									return "Near Destination"
	// 								}
	// 								else if (params.data.status == 4) {
	// 									return "Reached Destination"
	// 								}

	// 								else if (params.data.status == 5) {
	// 									return "Left Destination"
	// 								}
	// 								else if (params.data.status == 6) {
	// 									return "Force Closed"
	// 								}
	// 								else if (params.data.status == 8) {
	// 									return "Crossdock"
	// 								}else if(params.data.status == 9){
	// 									return "Trip Completed"
	// 								}
	// 								else {
	// 									return ""
	// 								}

	// 							}
	// 						},
	// 						{
	// 							headerName: "Zone",
	// 							field: "zone",
	// 							width: 100,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
							
	// 						{
	// 							headerName: "Dealer Code",
	// 							field: "consignee_code",
	// 							width: 100,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Dealer City",
	// 							field: "consignee_city",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},

	// 						{
	// 							headerName: "Dealer Name",
	// 							field: "consignee_name",
	// 							width: 120,
	// 							resizable: true,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Trip Distance (KM)",
	// 							field: "distance_in_km",
	// 							width: 120,
	// 							resizable: true,
	// 							valueGetter: params =>{
	// 								if(params.data.distance_in_km>0){
	// 									return params.data.distance_in_km
	// 								}else{
	// 									return 0
	// 								}
	// 							}
	// 							,
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Distance from Dealer (KM)",
	// 							field: "distance_from_dealer_location",
	// 							width: 160,
	// 							valueGetter: function (params) {
	// 								if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
	// 									return params.data.distance_from_dealer_location;
	// 								}
	// 								else {
	// 									return "";
	// 								}
	// 							},
	// 							// cellClass: function (params) {
	// 							// 	if (params.data.transit_delay == 1) {
	// 							// 		return 'lightred';
	// 							// 	}
	// 							// 	else {
	// 							// 		return '';
	// 							// 	}

	// 							// }
	// 						},
	// 						{
	// 							headerName: "Reached Destination At",
	// 							field: "first_dealer_reported",
	// 							width: 180,


	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Left Destination At",
	// 							field: "left_dealer_marked",
	// 							width: 180,
	// 							//filter: "agDateColumnFilter",
	// 							//cellRenderer:'dateFormater',
	// 							valueGetter: function (params) {
	// 								if (params.data.status == 5) {
	// 									return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
	// 								}
	// 								else {
	// 									return "";
	// 								}

	// 							},
	// 							resizable: true,

	// 						},
	// 						{
	// 							headerName: "Transit Time (Days)",
	// 							field: "transit_time",
	// 							width: 200,
	// 							filter: "agSetColumnFilter",
	// 							cellRenderer: '', resizable: true
	// 						},
							
	// 					],
	// 					overlayNoRowsTemplate: 'No rows to show',
	// 					onCellClicked:(leg_params) =>{
	// 						if(leg_params.colDef.field =="legs_map"){
	// 							if(leg_params.data.status==8){
	// 								this.setState({
	// 									show: true,
	// 									basicTitle: 'No Route data available',
	// 									basicType: "danger",
	// 									loadshow: 'show-n'
	// 								});
	// 							}else{
								
	// 								var leg_params = leg_params.data
	// 								this.setState({
	// 									loadshow: 'show-m',
	// 									maptruckno: leg_params.truck_no
	// 								});
							
	// 								// If gateouttime is current time - It shows "No Route data available"
	// 								if (leg_params.invoice_time) {
	// 									var gateouttime = moment.parseZone(leg_params.invoice_time).format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								else {
	// 									if (leg_params.gate_in_time) {
	// 										var gateouttime = moment.parseZone(leg_params.gate_in_time).format('YYYY-MM-DD HH:mm:ss');
	// 									}
	// 									else {
	// 										if (leg_params.gate_out_time) {
	// 											var gateouttime = moment.parseZone(leg_params.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
	// 										}
	// 									}
	// 								}
							
	// 								var edate = '';
	// 								var end_date;
	// 								if (leg_params.status <= 2) {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}
	// 								else if (leg_params.status == 3 || leg_params.status == 4) {
	// 									if (leg_params.recent_dealer_reported) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 										end_date = getHyphenYYYYMMDDHHMMSS(leg_params.recent_dealer_reported);
	// 									}
	// 								}
	// 								else if (leg_params.status == 5) {
	// 									if (leg_params.left_dealer_marked) {
	// 										edate = getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 										end_date =  getHyphenYYYYMMDDHHMMSS(leg_params.left_dealer_marked);
	// 									}
	// 								}
	// 								else if (leg_params.status == 6) {
	// 									if (leg_params.force_closure_time) {
	// 										let splitT = leg_params.force_closure_time.split('T')
	// 										let yMD = splitT[0]
	// 										let hMS = splitT[1]
	// 										let hms1 = hMS.split('.')
	// 										let finalHms = hms1[0]
	// 										let final_end_date = yMD + ' ' + finalHms
	// 										end_date = final_end_date;
	// 										edate = final_end_date
	// 									}
	// 								}
	// 								else {
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 									edate = getHyphenYYYYMMDDHHMMSS(end_date);
	// 								}							
	// 								if ((leg_params.transit_time) > 0) {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + ((leg_params.transit_time + 1) * 24 * 60 * 60 * 1000));
	// 								}
	// 								else {
	// 									var seconddate = new Date(new Date(leg_params.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
	// 								}
							
	// 								var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();
							
	// 								if (!end_date) {
	// 									// When end date is unavailable then current date is considered as end date.
	// 									end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
	// 								}
	// 								var reqData = {
	// 									truck_no: leg_params.truck_no,
	// 									consignment_code: leg_params.invoice_no,
	// 									consignee_code: leg_params.consignee_code,
	// 									gate_out_time: gateouttime,
	// 									seconddate: end_date,
	// 									screen: "consignment"
	// 								}
	// 								if (["2", "3", "4"].includes(leg_params.status)) reqData.mapMode = 2
							
	// 								redirectURL.post('/consignments/maproutes', reqData, {
	// 									headers: {
	// 										'content-type': 'application/json'
	// 									}
	// 								})
	// 									.then((response) => {
	// 										var records = response.data;
	// 										console.log(records,"record3535")
	// 										this.setState({
	// 											loadshow: 'show-m'
	// 										});
	// 										try {
	// 											if (records.coords.length == 0 || records.status == "failure") {
	// 												this.setState({
	// 													show: true,
	// 													basicTitle: 'No Route data available',
	// 													basicType: "danger",
	// 													loadshow: 'show-n'
	// 												});
	// 											}
	// 											else {
	// 												if (records != '') {
	// 													var sdate = leg_params.gate_out_time;
	// 													if (leg_params.invoice_time) {
	// 														var sdate = leg_params.invoice_time;
	// 													}
	// 													else {
	// 														if (leg_params.gate_in_time) {
	// 															var sdate = leg_params.gate_in_time;
	// 														}
	// 														else {
	// 															if (leg_params.gate_out_time) {
	// 																var sdate = leg_params.gate_out_time;
	// 															}
	// 														}
	// 													}
							
							
	// 													var edate = '';
	// 													var end_date = ""
	// 													console.log(leg_params.recent_dealer_reported , "recent_dealer_reported")
	// 													if (leg_params.status < 4) {
	// 														end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 														edate = getHyphenDDMMYYYYHHMMSS(end_date);
							
	// 													}
	// 													else if (leg_params.status == 4 ) {
	// 														console.log("end_time", leg_params)
	// 														edate = getHyphenDDMMYYYYHHMMSS(leg_params.end_time);
	// 														end_date = leg_params.recent_dealer_reported
	// 													}
	// 													else if (leg_params.status == 5) {
	// 														if (leg_params.left_dealer_marked) {
	// 															edate = getHyphenDDMMYYYYHHMMSS(leg_params.left_dealer_marked);
	// 															end_date = leg_params.left_dealer_marked
							
	// 														}
	// 														else {
	// 															end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
	// 															edate = getHyphenDDMMYYYYHHMMSS(end_date);
	// 														}
	// 													}
	// 													if (leg_params.deviation_flag == 1 && this.state.deptcode == "LOG-PRT") {
	// 														var params = {
	// 															"base_route_id": leg_params.base_route_id
	// 														}
	// 														redirectURL.post("/consignments/getLiveRouteDeviationBaseRoute",
	// 															params).then((resp) => {
	// 																this.setState({
	// 																	sliderRouteTranslate: "slider-translate-60p",
	// 																	showDiv: 'show-m',
	// 																	mapinfo: records,
	// 																	dealer: leg_params.consignee_code,
	// 																	consignment_code: "Truck No : " + leg_params.truck_no,
	// 																	maptruckno: leg_params.truck_no,
	// 																	routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 																	loadshow: 'show-n',
	// 																	sidebarSubHeader: "Consignment Information",
	// 																	overly: 'show-m',
	// 																	rownode: leg_params,
	// 																	leg_no: 0,
	// 																	tolls: records.tolls,
	// 																	baseRouteCoords: resp.data.alteredHeroPRTBaseRoute,
	// 																	devation_flag: true
	// 																});
	// 																this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 																this.renderMap();
	// 															})
	// 													}
	// 													else {
	// 														this.setState({
	// 															sliderRouteTranslate: "slider-translate-60p",
	// 															showDiv: 'show-m',
	// 															mapinfo: records,
	// 															dealer: leg_params.consignee_code,
	// 															consignment_code: "Invoice No : " + leg_params.invoice_no,
	// 															maptruckno: leg_params.truck_no,
	// 															routeTruck: { "truck_no": leg_params.truck_no, "startTime": sdate, "endTime": end_date },
	// 															loadshow: 'show-n',
	// 															sidebarSubHeader: "Consignment Information",
	// 															overly: 'show-m',
	// 															rownode: leg_params,
	// 															leg_no: 0,
	// 															tolls: records.tolls
	// 														});
	// 														this.onShowGoogleRoute(leg_params.invoice_no, leg_params.consignee_code, 0, leg_params.truck_no)
	// 														this.renderMap();
	// 													}
	// 												}
	// 											}
	// 										}
	// 										catch (e) {
	// 											this.setState({
	// 												show: true,
	// 												basicTitle: 'No Route data available',
	// 												basicType: "danger",
	// 												loadshow: 'show-n'
	// 											});
	// 										}
							
	// 									})
	// 									.catch(function (error) {
	// 										console.log(error);
	// 									});
	// 							}
	// 						}
	// 					}
	// 				},
	// 				getDetailRowData: function (params) {
	// 					console.log("Step 4 ", transitedelaydata)
	// 					console.log("Step 4 ", params)
	// 					redirectURL.post('/consignments/getShipmentDetails', {
	// 						shipment_id: params.data.shipment_id
	// 					})
	// 						.then(async (response) => {
	// 							console.log(response.data , "srinu")
	// 							params.successCallback(response.data || []);
	// 							//console.log("Step 2 ",response.data)

	// 						});

	// 				}
	// 			}
	// 		});

	// 		//if( params.column.colId == 'transit_delay' || params.column.colId == 'transit_delay_1' ||   params.column.colId == 'no_gps_data' || params.column.colId == 'no_gps_data_1')
	// 		if (params.column.colDef.field == 'shipmentlegs') {
	// 			params.node.setExpanded(!params.node.expanded);
	// 			//console.log("expanded ",params.node.expanded)
	// 			if (params.node.expanded == false) {
	// 				transitedelaydata = []
	// 			}
	// 		}
	// 		else {

	// 			params.node.setExpanded(false);
	// 		}
	// 		//console.log("detailCellRendererParams ", this.state.detailCellRendererParams);

	// 	}

	// }
    
 const   onShowCourierTrack = async (params) => {
    console.log(params, "paramsshipment")
		// if (googleAnalytics.page.enableGA) {
		// 	let pageTitle = this.state.pageTitle;
		// 	// let eventOptions = {
		// 	// 	"category": pageTitle,
		// 	// 	"action": this.state.eventGridAction,
		// 	// 	"label": googleAnalytics.page.action.trackCourier,
		// 	// }
		// 	// googleAnalytics.logEvent(eventOptions);
		// }

        redirectURL.post('/consignments/trackcourier',{consignment_code :params.data.consignment_code} )
        .then(resp => {
            console.log(resp, "respppppp")
            if (resp.data.consignments?.length > 0) {
                params.node.setExpanded(!params.node.expanded)
                setdetailCellRendererParams({
                    detailGridOptions: {
                        columnDefs: [
							
							{
                                headerName: "Transit Date",
                                field: "transitdatetime", 
                                valueGetter: function(params) {
                                    let transitDateTime = params.data.transitdatetime;                            
                                    if (!transitDateTime) {
                                        return '';
                                    }
                                    let momentDate;
                                    if (moment(transitDateTime, "DD-MM-YYYY HH:mm:ss", true).isValid()) {
                                        momentDate = moment(transitDateTime, "DD-MM-YYYY HH:mm:ss");
                                    } 
                                    else if (moment(transitDateTime, "DD-MMM-YYYY HH:mm", true).isValid()) {
                                        momentDate = moment(transitDateTime, "DD-MMM-YYYY HH:mm");
                                    } 
                                    else if (params.data.transitdatetimeseconds) {
                                        momentDate = moment(parseInt(params.data.transitdatetimeseconds));
                                    }
                                    if (!momentDate) {
                                        return transitDateTime;
                                    }
                                    return momentDate.format("DD-MM-YYYY HH:mm:ss");
                                },
                            
                                filter: true,
                                resizable: true
                            },
                                                    
							{ 
                                headerName: "Location",
                                field: "intransit_location", 
                                filter:true,
								resizable:true 
                            },
							{ 
                                headerName: "Status",
                                field: "intransit_status", 
                                filter:true ,
								resizable:true
                            }
						],	
                        defaultColDef: {
                            flex: 3,
                        },
                    },
                    getDetailRowData: (params) => {
                        // params.successCallback(resp.data);
                        params.successCallback(resp.data.consignments);
                    },
                })
            // }
        // })
        // .catch(err => {
        //     console.log(err);
        // })
            }})
        // if(params != 0)
		// {
			
		// 	await this.setState({
					
		// 		setdetailCellRendererParams:{
		// 			detailGridOptions: {
												
		// 			},
		// 			getDetailRowData: function(params) {
		// 				//console.log("Step 4 ",overspeedData)
		// 				redirectURL.post('/consignments/trackcourier', {
		// 					consignment_code:params.data.consignment_code
		// 				})
		// 				.then(async (response) =>{
        //                     //console.log("Step 1 ",response.data)
        //                     //console.log("test ", response);
        //                     var trackData=response.data;
        //                     //console.log("trackData ", trackData)
        //                     if(trackData.status == 'failure')
        //                     {
        //                         params.successCallback([]);
        //                     }
        //                     else{
        //                         params.successCallback(trackData);
        //                     }
							
		// 					//console.log("Step 2 ",response.data)
							
		// 				});
						 
		// 			},
		// 			masterDetail: true
		// 		}
		// 	});
			
		// 	//console.log("detailCellRendererParams ", this.state.detailCellRendererParams);
			
		// }
		// //console.log("params.column.colId ", params.column)
		// if(params.column.colDef.field == '_id')
		// {
		// 	params.node.setExpanded(!params.node.expanded);
		// }
		// else{

		// 	params.node.setExpanded(false);
		// }
    }
    const onClickShowShipmentLegs = async (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code
        }
        redirectURL.post('/consignments/getShipmentDetails', query)
            .then(resp => {
                console.log(resp, "respppppp")
                if (resp.data.consignments?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: [
                                // {
                                //     headerName: "",
                                //     field: "legs_map",
                                //     colId: "legs_map",
                                //     width: 40,
                                //     pinned: 'left',
                                //     cellRenderer:function(params){
                                //         var htmloption = '<i class="icofont icofont-map-pins f25" style="padding:0 9px"></i>';
                                //         return htmloption;
                                //     } ,
                                //     filter: false, resizable: true
                
                                // },
                                {
                                    headerName: "Invoice No",
                                    field: "invoice_no",
                                    width: 140,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                // {
                                //     headerName: "Consignment",
                                //     field: "consignment_code",
                                //     width: 140,
                                //     // cellClass: function (params) {
                                //     // 	if (params.data.transit_delay == 1) {
                                //     // 		return 'lightred';
                                //     // 	}
                                //     // 	else {
                                //     // 		return '';
                                //     // 	}
    
                                //     // }
                                // },
                                {
                                    headerName: "Original ETA",
                                    field: "expected_trip_end",
                                    width: 10,
                                    valueGetter: function (params) {
                                        return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
                                    },
                                    cellClass: function (params) {
                                        if (params.data.transit_delay == 1) {
                                            return 'lightred';
                                        }
                                        else {
                                            return '';
                                        }
                                    },
    
                                },
                                {
                                    headerName: "Revised ETA",
                                    field: "revised_trip_end",
                                    width: 180,
                                    valueGetter: function (params) {
                                        return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
                                    },
                                    cellClass: function (params) {
                                        if (params.data.transit_delay == 1) {
                                            return 'lightred';
                                        }
                                        else {
                                            return '';
                                        }
    
                                    }
                                },
                                
                                {
                                    headerName: "Status",
                                    field: "status",
                                    width: 140,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // },
                                    
    
                                    valueGetter: function (params) {
                                        //console.log("GPS ", params.data.gps_data_available);
                                        if (params.data.status == 1) {
                                            return "Inside Plant"
                                        }
                                        else if (params.data.status == 2) {
                                            return "In Transit"
                                        }
                                        else if (params.data.status == 3) {
                                            return "Near Destination"
                                        }
                                        else if (params.data.status == 4) {
                                            return "Reached Destination"
                                        }
    
                                        else if (params.data.status == 5) {
                                            return "Left Destination"
                                        }
                                        else if (params.data.status == 6) {
                                            return "Force Closed"
                                        }
                                        else if (params.data.status == 8) {
                                            return "Crossdock"
                                        }else if(params.data.status == 9){
                                            return "Trip Completed"
                                        }
                                        else {
                                            return ""
                                        }
    
                                    }
                                },
                                // {
                                //     headerName: "Zone",
                                //     field: "zone",
                                //     width: 100,
                                //     // cellClass: function (params) {
                                //     // 	if (params.data.transit_delay == 1) {
                                //     // 		return 'lightred';
                                //     // 	}
                                //     // 	else {
                                //     // 		return '';
                                //     // 	}
    
                                //     // }
                                // },
                                
                                {
                                    headerName: "Dealer Code",
                                    field: "consignee_code",
                                    width: 200,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Dealer City",
                                    field: "consignee_city",
                                    width: 120,
                                    resizable: true,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
    
                                {
                                    headerName: "Dealer Name",
                                    field: "consignee_name",
                                    width: 150,
                                    resizable: true,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Trip Distance (KM)",
                                    field: "distance_in_km",
                                    width: 150,
                                    resizable: true,
                                    valueGetter: params =>{
                                        if(params.data.distance_in_km>0){
                                            return params.data.distance_in_km
                                        }else{
                                            return 0
                                        }
                                    }
                                    ,
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Distance from Dealer (KM)",
                                    field: "distance_from_dealer_location",
                                    width: 200,
                                    valueGetter: function (params) {
                                        if (params.data.distance_from_dealer_location != '' && params.data.distance_from_dealer_location != null) {
                                            return params.data.distance_from_dealer_location;
                                        }
                                        else {
                                            return "";
                                        }
                                    },
                                    // cellClass: function (params) {
                                    // 	if (params.data.transit_delay == 1) {
                                    // 		return 'lightred';
                                    // 	}
                                    // 	else {
                                    // 		return '';
                                    // 	}
    
                                    // }
                                },
                                {
                                    headerName: "Reached Destination At",
                                    field: "first_dealer_reported",
                                    width: 180,
    
    
                                    //cellRenderer:'dateFormater',
                                    valueGetter: function (params) {
                                        if (params.data.status == 4 || params.data.status == 5 || params.data.status == 3) {
                                            return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported);
                                        }
                                        else {
                                            return "";
                                        }
    
                                    },
                                    resizable: true,
    
                                },
                                {
                                    headerName: "Left Destination At",
                                    field: "left_dealer_marked",
                                    width: 180,
                                    //filter: "agDateColumnFilter",
                                    //cellRenderer:'dateFormater',
                                    valueGetter: function (params) {
                                        if (params.data.status == 5) {
                                            return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                                        }
                                        else {
                                            return "";
                                        }
    
                                    },
                                    resizable: true,
    
                                },
                                {
                                    headerName: "Transit Time (Days)",
                                    field: "transit_time",
                                    width: 200,
                                    filter: "agSetColumnFilter",
                                    cellRenderer: '', resizable: true
                                },
                                
                            ],
                            defaultColDef: {
                                flex: 3,
                            },
                        },
                        getDetailRowData: (params) => {
                            // params.successCallback(resp.data);
                            params.successCallback(resp.data.consignments);
                        },
                    })
                // }
            // })
            // .catch(err => {
            //     console.log(err);
            // })
                }})}
// })};
    // const handleCellClick = (leg_params) => {
    //     setLoadshow('show-m');
    //     setMaptruckno(leg_params.data.truck_no);

    //     let gateouttime = getGateOutTime(leg_params.data);

    //     let end_date = getEndDate(leg_params.data);
    //     let edate = getHyphenYYYYMMDDHHMMSS(end_date);

    //     let sdate = getSecondDate(leg_params.data);

    //     if (!end_date) {
    //         end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
    //         edate = getHyphenYYYYMMDDHHMMSS(end_date);
    //     }

    //     const reqData = {
    //         truck_no: leg_params.data.truck_no,
    //         consignment_code: leg_params.data.invoice_no,
    //         consignee_code: leg_params.data.consignee_code,
    //         gate_out_time: gateouttime,
    //         seconddate: end_date,
    //         screen: "consignment"
    //     };

    //     if (["2", "3", "4"].includes(leg_params.data.status)) reqData.mapMode = 2;

    //     redirectURL.post('/consignments/maproutes', reqData, {
    //         headers: {
    //             'content-type': 'application/json'
    //         }
    //     })
    //         .then(response => handleRouteResponse(response, leg_params.data))
    //         .catch(error => console.error(error));
    // };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };


    const onShowTransitRouteMap = (rownode) => {
        var d = new Date(rownode.leg_start);
        var r = new Date(rownode.leg_end_eta);
        var fintance = rownode.leg_start.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.leg_end_eta.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';

                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const onShowEnrouteRouteMap = (rownode) => {
        var fintance = rownode.stoppage_start_time.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        if (rownode.reset_datetime) {
            var eintance = rownode.reset_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        }
        else {
            var eintance = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                let records = response.data
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    if (response.data.route_details.start_time != "" && response.data.route_details.start_time != undefined) {
                        sdate = records.route_details.start_time;
                    }
                    if (response.data.route_details.end_time != "" && response.data.route_details.end_time != undefined) {
                        edate = records.route_details.end_time;
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNightDriveRouteMap = (rownode) => {
        var fintance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        consignment_code: rownode.truck_no,
                        defTransitCoords: { "lat": rownode.first_lat, "lng": rownode.first_lng },
                        maptruckno: rownode.truck_no,
                        routeTruck: {
                            "truck_no": rownode.truck_no, "startTime": response.data['route_details']['start_time'],
                            "endTime": response.data['route_details']['end_time']
                        },
                        loadshow: 'show-n',
                        tolls: response.data.tolls
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const onShowRouteMap = (rownode) => {
        var d = new Date(rownode.first_instance);
        var r = new Date(rownode.recent_instance);
        var finstance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var rinstance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: finstance,
            recent_instance: rinstance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/overspeedgpsroutes', params)
            .then((response) => {
                setOpenMap({
                    overly: "show-m",
                    sliderRouteTranslate: "slider-translate-60p",
                    mapinfo: response.data,
                    dealer: rownode.consignee_code,
                    consignment_code: "Vehicle No. : " + rownode.truck_no,
                    maptruckno: rownode.truck_no,
                    routeTruck: { "truck_no": rownode.truck_no, "startTime": finstance, "endTime": rinstance },
                    loadshow: 'show-n',
                    sidebarSubHeader: "Consignment Leg Information",
                    overly: 'show-m',
                    rownode: rownode,
                    leg_no: rownode.leg_no,
                    tolls: response.data.tolls,
                    defTransitCoords: rownode.consignee_coordinates,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNoGPSRouteMap = (rownode) => {
        var fintance = rownode.last_packet_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        eintance = eintance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim()
        if ((rownode.hasOwnProperty("exception_closed") && rownode.exception_closed == 1) || rownode.hasOwnProperty("packet_received_on"))
            eintance = rownode.packet_received_on.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment"
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "Vehicle No. : " + rownode.truck_no,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });



    }
    const userClickedTab = (e) => {
        var tabname = e.currentTarget.id;
        // console.log("Tabname ", tabname);
    
        if (tabname === "active") {
            setTabName(tabOptions[0]);
            navigate("/activeptlconsignments");
            loadConsignmentsData()
            setSearchConsigner([{ label: 'All', value: 'all' }]);
            setSearchTransporters({value: "", label: ""});
            setSearchStates({value: "", label: ""});
            setSearchCity({value:"", label: ""});
            setStartDate('');
            setEndDate('');
            setSeachValue("");
            setLrNo({value:"", label:""});
            setSearchType({ label: "Invoice No", value: "invoice_no" })
            setSearchInvoice({value: "", label:""});
            setSearchVehicle({ value:"", label:"" });
        } else if (tabname === "completed") {
            loadConsignmentsData()
            setTabName(tabOptions[1]);
            navigate("/deliveredptlconsignments");
            setSearchConsigner([{ label: 'All', value: 'all' }]);
            setSearchTransporters({value: "", label: ""});
            setSearchStates({value: "", label: ""});
            setSearchCity({value:"", label: ""});
            setStartDate('');
            setEndDate('');
            setSeachValue("");
            setSearchType({ label: "Invoice No", value: "invoice_no" })
            setLrNo({value:"", label:""});
            setSearchInvoice({value: "", label:""});
            setSearchVehicle({ value:"", label:"" });
        } else if (tabname === "all") {
            loadConsignmentsData()
            setTabName(tabOptions[2]);
            navigate("/allptlconsignments");
            setSearchConsigner([{ label: 'All', value: 'all' }]);
            setSearchTransporters({value: "", label: ""});
            setSearchStates({value: "", label: ""});
            setSearchCity({value:"", label: ""});
            setSearchType({ label: "Invoice No", value: "invoice_no" })
            setStartDate('');
            setEndDate('');
            setSeachValue("");
            setLrNo({value:"", label:""});
            setSearchInvoice({value: "", label:""});
            setSearchVehicle({ value:"", label:"" });
        } else if (tabname === "inactive") {
            loadConsignmentsData()
            setTabName(tabOptions[3]);
            navigate("/inactiveptlconsignments");
            setSearchConsigner([{ label: 'All', value: 'all' }]);
            setSearchTransporters({value: "", label: ""});
            setSearchType({ label: "Invoice No", value: "invoice_no" })
            setSearchStates({value: "", label: ""});
            setSearchCity({value:"", label: ""});
            setStartDate('');
            setEndDate('');
            setSeachValue("");
            setLrNo({value:"", label:""});
            setSearchInvoice({value: "", label:""});
            setSearchVehicle({ value:"", label:"" });
        }
    };
    const onClickOpenBulkUploadModal = (e) => {
        setOverlay("show-m")
        setBulkUploadModal({
            overly: "show-m",
            bulkPrioritySlide: "slider-translate-84p"
        })
    }
    const closeBulkUploadModal = () => {
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setOverlay("show-n")
        setModalLoadData([])
    }
    const onClickHideManualUpload2 = () => {
        setshowAddForm2("");
        setOverlay("show-n");
        setForm2Details({
            event_status: [
              { label: 'InTransit', value: 'InTransit' }, 
              { label: 'Near Destination', value: 'near_destination' },
              { label: 'Reached Destination', value: 'reached_destination' },
              { label: 'Delivered', value: 'delivered' },
              { label: 'UnDelivered', value: 'Undelivered' },
            ],
            selectedStatus: {value: 'InTransit', label: 'InTransit'},
            event_location: "",
            remark: "",
            delivered_date:'',
        })
      };
    const closeMapModal = () => {
        setOverlay("show-n")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setMapDetails()
    }
    const openMapModal = () => {

    }
    var lrBasedSegData = []
    var arrayOfArrays = []
    var lrNoOptions = []
    
    const CounterClick = (ecounter) => {
        console.log(ecounter,"valueeeeeeeeeeee");
        if (tabName.value == "active") {
            switch (ecounter) {
                case "consignments":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...y,...intransitColDefs]);
                    setRowData(activeTrips.all);
                    break;
                case "in_transit":
                    setCounterActive(ecounter)

                    setColumnWithDefs([...y, ...intransitColDefs]);

                    setRowData(activeTrips.in_transit);
                    lrBasedSegData = activeTrips.in_transit.reduce((acc, cur)=>{
                        let curLrno = cur.lr_no;
                        if(!acc[curLrno]){
                            acc[curLrno] = new Set();
                        }
                        acc[curLrno].add(cur.invoice_no);
                        return acc;
                    }, [])
                    console.log(lrBasedSegData,"lrBasedSegData");
                    lrNoOptions = Object.entries(lrBasedSegData).map(([key, set]) => {
                        return Array.from(set).map(item => ({ value: key, label: item }));
                    }).flat();
                    
                    console.log(lrNoOptions, "lrNoOptions");
                    setLrOptions(lrNoOptions);
                    break;
                case "outfordelivery": 
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.out_for_delivery);
                    break;
                case "cancelled":
                    setCounterActive(ecounter)
                    setRowData(activeTrips.cancelled);
                    break;
                case "tracking_na":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.tracking_na);
                    break;
                case "transit_delays":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.transit_delay)
                    break;
                // case "overspeeding":
                //     setRowData(activeTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(activeTrips.night_driving)
                //     break;
                case "stoppages":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.stoppages)
                    break;
                case "accidents":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.accidents)
                    break;
                case "trip_deviations":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.no_gps_data)
                    break;
                case "no_gps_data_lifetime":
                    setCounterActive(ecounter)
                    setColumnWithDefs([...intransitColDefs]);
                    setRowData(activeTrips.no_gps_data_lifetime)
                    break;
                default:
                    break;
            }
        }
        else if (tabName.value == "completed") {
            switch (ecounter) {
                case "consignments":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.all)
                    break;
                case "transit_delays":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.transit_delay)
                    break;
                // case "overspeeding":
                //     setRowData(completedTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(completedTrips.night_driving)
                //     break;
                case "stoppages":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.stoppages)
                    break;                
                case "delivered": 
                    setCounterActive(ecounter)
                    setRowData(completedTrips.delivered)
                    break;
                case "ontime":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.ontime)
                    break;
                case "delayed":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.delayed)
                    break;
                case "accidents":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.accidents)
                    break;
                case "trip_deviations":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.no_gps_data)
                    break;
                case "no_gps_data_lifetime":
                    setCounterActive(ecounter)
                    setRowData(completedTrips.no_gps_data_lifetime)
                    break;
                default:
                    break;
            }
        }
        else if (tabName.value == "all") {
            switch (ecounter) {
                case "consignments":
                    setCounterActive(ecounter)
                    setRowData(allTrips.all)
                    break;
                case "picked_up":
                    setCounterActive(ecounter)
                    setRowData(allTrips.picked_up);
                    break;
                case "in_transit":
                    setCounterActive(ecounter)
                    setRowData(allTrips.in_transit);
                    break;
                case "outfordelivery":
                    setCounterActive(ecounter) 
                    setRowData(allTrips.out_for_delivery);
                    break;                               
                case "delivered": 
                    setCounterActive(ecounter)
                    setRowData(allTrips.delivered)
                    break;
                case "tracking_na":
                    setCounterActive(ecounter)
                    setRowData(allTrips.tracking_na);
                    break;                                 
                case "undelivered":
                    setCounterActive(ecounter)
                    setRowData(allTrips.undelivered);
                    break;
                case "cancelled":
                    setCounterActive(ecounter)
                    setRowData(allTrips.cancelled);
                    break;
                case "transit_delays":
                    setCounterActive(ecounter)
                    setRowData(allTrips.transit_delay)
                    break;   
                // case "overspeeding":
                //     setRowData(allTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(allTrips.night_driving)
                //     break;
                case "stoppages":
                    setCounterActive(ecounter)
                    setRowData(allTrips.stoppages)
                    break;
                case "accidents":
                    setCounterActive(ecounter)
                    setRowData(allTrips.accidents)
                    break;
                case "trip_deviations":
                    setCounterActive(ecounter)
                    setRowData(allTrips.trip_deviations)
                    break;
                case "loading_delay":
                    setCounterActive(ecounter)
                    setRowData(allTrips.loading_delay)
                    break;
                case "unloading_delay":
                    setCounterActive(ecounter)
                    setRowData(allTrips.unloading_delay)
                    break;
                case "no_gps_data":
                    setCounterActive(ecounter)
                    setRowData(allTrips.no_gps_data)
                    break;
                case "no_gps_data_lifetime":
                    setCounterActive(ecounter)
                    setRowData(allTrips.no_gps_data_lifetime)
                    break;
                default:
                    break;
            }
        }
        else if (tabName.value == "inactive") {
            switch (ecounter) {
                case "consignments":
                    setCounterActive(ecounter)
                    setRowData(inactiveTrips.all)
                    break;
                case "ontime":
                    setCounterActive(ecounter)
                    setRowData(inactiveTrips.on_time);
                    break;
                case "delayed":
                    setCounterActive(ecounter)
                    setRowData(inactiveTrips.delayed);
                    break;
                case "no_data":
                    setCounterActive(ecounter)
                    setRowData(inactiveTrips.no_data);
                    break;

                // case "transit_delays":
                //     setRowData(allTrips.transit_delay)
                //     break;
                // case "overspeeding":
                //     setRowData(allTrips.overspeeding)
                //     break;
                // case "night_driving":
                //     setRowData(allTrips.night_driving)
                //     break;
                // case "stoppages":
                //     setRowData(allTrips.stoppages)
                //     break;
                // case "accidents":
                //     setRowData(allTrips.accidents)
                //     break;
                // case "trip_deviations":
                //     setRowData(allTrips.trip_deviations)
                //     break;
                // case "loading_delay":
                //     setRowData(allTrips.loading_delay)
                //     break;
                // case "unloading_delay":
                //     setRowData(allTrips.unloading_delay)
                //     break;
                // case "no_gps_data":
                //     setRowData(allTrips.no_gps_data)
                //     break;
                // case "no_gps_data_lifetime":
                //     setRowData(allTrips.no_gps_data_lifetime)
                //     break;
                default:
                    break;
            }
        }
    }
    const onClickCancelActiveCourierConsignemnts = (e) => {
        console.log(e,"selectedForCancellation");
        setCloseCancelModal(true)
        setRownode(e.data)
        setReasonForCancellation("");
        
        // lrNoOption
        console.log(lrNoOptions,"331888888888888888888888");
        const filteredLrOptions = lrNoOptions.filter(m => {
            console.log(m,"MMMMMMMMMM");
            return m.label !== "undefined" && m.value === e.data.lr_no;
        });
        console.log(filteredLrOptions,"filteredLrOptions")
        setLrOptions(filteredLrOptions)
    }
    useEffect( () => {
        let key = ''
        redirectURL.post('/details')
            .then((response) => {
                if (response.data.status === 'success') {
                    setKey(response.data.output[0].g_key);
                    key = response.data.output[0].g_key
                    loadScript("https://maps.googleapis.com/maps/api/js?key=" + key + "&libraries=places,drawing&callback=initMap");
                    window.initMap = () => {
                        var lt = 28.4519751;
                        var ln = 77.0310713;
                        map = new window.google.maps.Map(document.getElementById('map_canvas'), {
                            zoom: 13,
                            center: new window.google.maps.LatLng(lt, ln),
                            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });

        redirectURL.post('consignments/getConsigner')
            .then((response) => {
                setConsignersList(response.data.records)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });

            redirectURL.post("/consignments/getCourierLRConsignmentsNewFilterKeys", { dept_code: "SNDG" })
            .then((resp) => {
                console.log(resp, "responseseeee")
                var vehicles = resp.data.vehicles;

                let transporterSet = new Set();
                let vehicleNoSet = new Set();
                let stateSet = new Set();
                let invoiceSet = new Set();
                let citiesSet = new Set();
                let lrNoSet = new Set();

                var filteredVehicles = [];
                if(vehicles != undefined){
                    if (vehicles.length > 0) {
                        vehicles.map(function (c) {
                            if(!vehicleNoSet.has(c._id.toUpperCase())){
                                vehicleNoSet.add(c._id.toUpperCase())
                                filteredVehicles.push({
                                    label: c._id,
                                    value: c._id,
                                });                                
                            }
                        });
                    }
                }
                console.log(filteredVehicles,"filteredVehicles")
                var cities = resp.data.cities;
                var filterCities = [];
                if (cities != undefined) {
                    if (cities.length > 0) {
                        cities.map(function (c) {
                            if(!citiesSet.has(c._id.toUpperCase())){
                                citiesSet.add(c._id.toUpperCase())
                                filterCities.push({
                                    label: c._id,
                                    value: c._id,
                                });
                            }
                        });
                    }
                }

                var states = resp.data.states;
                var filterStates = [];
                if (states != undefined) {
                    if (states.length > 0) {
                        states.map(function (s) {
                            if(!stateSet.has(s._id.toUpperCase())){
                                stateSet.add(s._id.toUpperCase())
                                filterStates.push({
                                    label: s._id,
                                    value: s._id,
                                });
                            }
                        });
                    }
                }
                var clusters = resp.data.clusters;
                var filterClusters = [];
                if (clusters != undefined) {
                    if (clusters.length > 0) {
                        clusters.map(function (cl) {
                            filterClusters.push({
                                label: cl,
                                value: cl,
                            });
                        });
                    }
                }

                var transporters = resp.data.transporters;
                var filterTransporters = [];
                if (transporters != undefined) {
                    if (transporters.length > 0) {
                        transporters.map(function (t) {
                            if(!transporterSet.has(t.toUpperCase())){
                                transporterSet.add(t.toUpperCase())
                                filterTransporters.push({
                                    label: t,
                                    value: t,
                                });
                            }                            
                        });
                    }
                }

                var invoiceNumbers = resp.data.invoices;
                var filteredInvoices = [];
                if(invoiceNumbers != undefined){
                    if(invoiceNumbers.length > 0){
                        invoiceNumbers.map(function (t){
                            if(!invoiceSet.has(t._id.toUpperCase())){
                                invoiceSet.add(t._id.toUpperCase())
                                filteredInvoices.push({
                                    label: t._id,
                                    value: t._id
                                })
                            }
                        })
                    }
                }

                var lrNos = resp.data.lrNos;
                var filteredLrnos = [];
                if(lrNos != undefined){
                    if(lrNos.length > 0){
                        lrNos.map(function (t){
                            if(!lrNoSet.has(t._id.toUpperCase())){
                                lrNoSet.add(t._id.toUpperCase())
                                filteredLrnos.push({
                                    label: t._id,
                                    value: t._id
                                })
                            }
                        })
                    }
                }
                setFilteredvehicles(filteredVehicles)
                setFilterCities(filterCities)
                setFilterStates(filterStates)
                setFilterTransporters(filterTransporters)
                setFilteredInvoices(filteredInvoices)
                setFilteredLrnos(filteredLrnos)
            })
        fetchGridLayout(user.email, "consignments")
            .then(res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    setGridColumnState(res.data.data[0].columnState)
                }
            })
            .catch(err => console.log(err))
    }, [])
    useEffect(()=>{
        loadConsignmentsData()
    },[tabActive])
    useEffect(() => {
        if (gridColumnState.length > 0 && columnApiConsignments.current) {
            columnApiConsignments.current.applyColumnState({
                state: gridColumnState,
                applyOrder: true,
            })
        }
    }, [gridColumnState, columnApiConsignments])
    useEffect(() => {
        console.log(tabName,"tabName");
        if(tabName.value === "inactive"){
            setRowData(inactiveTrips.all)
        }
        else if ( tabName.value == "active") {
            // window.location.href = "/activeftlconsignments"
            setRowData(activeTrips.all)
        }
        else if (tabName.value == "completed") {
            // window.location.href = "/deliveredftlconsignments"
            setRowData(completedTrips.all)
        }
        else if (tabName.value == "all") {
            // window.location.href = "/allftlconsignments"
            setRowData(allTrips.all)
        }
       
    }, [tabName.value])

    const changeFileHandler = (e) => {
        setLoader(true)
        const formData = new FormData()
        formData.append("fileUpload", e.target.files[0])
        redirectURL.post("/readptlExcel", formData, {
            headers: {
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': "*",
                'Access-Control-Allow-Methods': 'POST',
                'Access-Control-Allow-Headers': 'Origin, Content-Type'
            }
        })
            .then((response) => {
                if (response.data.status == "success") {
                    console.log(response.data,"MMMMMMMMMMMMMMMMM");
                    if (response.data.data.length > 0) {
                        
                        setModalLoadData(response.data.data)
                        // setPlantData(response.data.plantData)
                        // setTransporters(response.data.transporters)
                        // setDealers(response.data.dealers)
                        // setPreviousData(response.data.previousData)
                    }
                    else {
                        setModalLoadData([])
                    }
                }
                else {
                    setShow(true)
                    setTitle(response.data.message)
                    setType("danger")
                }
            })
            .catch(error => {
                console.log(error);
            })
        setLoader(false)
    }

    const onClickShowRoute = (rownode) => {
        setLoader(true)
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = rownode.data
        var gateouttime = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        var edate = '';
        var end_date;
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.recent_dealer_reported);
            }
        }
        else if (e.status == 5) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            }
            else if (e.left_dealer_marked) {
                end_date = e.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
            }
        }
        else if (e.status == 6) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            } else if (e.force_closure_time) {
                end_date = getHyphenDDMMMYYYYHHMM(e.force_closure_time);
            }
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        if ((e.transit_time) > 0) {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + ((e.transit_time + 1) * 24 * 60 * 60 * 1000));
        }
        else {
            var seconddate = new Date(new Date(e.gate_out_time).getTime() + 2 * 24 * 60 * 60 * 1000);
        }

        var sdate = seconddate.getFullYear() + "-" + (seconddate.getMonth() + 1) + "-" + seconddate.getDate() + " " + seconddate.getHours() + ":" + seconddate.getMinutes() + ":" + seconddate.getSeconds();

        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            //console.log("Defining end_date ", end_date);
        }
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: gateouttime,
            seconddate: end_date,
            screen: "consignment"
        }
        if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        redirectURL.post('/consignments/maproutes', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;
                // this.setState({
                //     loadshow: 'show-m'
                // });
                try {
                    if (records.coords.length == 0) {
                        setShow(true)
                        setTitle("No GPS data available")
                        setType("danger")
                    }
                    else {
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                var sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    var sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        var sdate = e.gate_out_time;
                                    }
                                }
                            }
                            var edate = '';
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = getHyphenDDMMMYYYYHHMM(end_date);
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = getHyphenDDMMMYYYYHHMM(end_date);
                                }
                            }
                            if (e.deviation_flag == 1) {
                                let consignee_city;
                                consignee_city = e.consignee_city
                                var params = {
                                    "base_route_id": e.base_route_id,
                                    "consigner_code": e.consigner_code,
                                    "consignee_city": consignee_city
                                }
                                redirectURL.post("/consignments/getDeviationRouteBaseRoute",
                                    params).then((resp) => {
                                        var baseRouteCoords = eval(resp.data.route_coords);
                                        setOpenMap({
                                            overly: "show-m",
                                            sliderRouteTranslate: "slider-translate-60p",
                                            mapinfo: records,
                                            dealer: e.consignee_code,
                                            consignment_code: "Consignment : " + e.consignment_code,
                                            maptruckno: e.truck_no,
                                            routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                            loadshow: 'show-n',
                                            sidebarSubHeader: "Consignment Information",
                                            rownode: e,
                                            leg_no: 0,
                                            tolls: records.tolls,
                                            baseRouteCoords: baseRouteCoords
                                        })
                                    })
                                setLoadShow("show-n")
                            }
                            else {
                                var params =
                                {
                                    consignee_code: e.consignee_code,
                                    dept_code: e.dept_code
                                }
                                redirectURL.post('/consignments/geofencedata', params).then((response) => {
                                    var records1 = response.data.records;
                                    let parkingGeodata = []
                                    if (response.data.parkingGeofence[0] !== undefined) parkingGeodata = response.data.parkingGeofence[0]
                                    var geofence_coords = []
                                    if (records1.length) {
                                        geofence_coords = records1[0].geofence_coordinates;
                                    }
                                    setOpenMap({
                                        sliderRouteTranslate: "slider-translate-60p",
                                        showDiv: 'show-m',
                                        mapinfo: records,
                                        dealer: e.consignee_code,
                                        consignment_code: "Consignment : " + e.consignment_code,
                                        maptruckno: e.truck_no,
                                        geofence_coordinates: geofence_coords,
                                        parking_coordinates: parkingGeodata,
                                        routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                        loadshow: 'show-n',
                                        sidebarSubHeader: "Consignment Information",
                                        overly: 'show-m',
                                        rownode: e,
                                        leg_no: 0,
                                        tolls: records.tolls
                                    })
                                    setLoadShow("show-n")
                                })
                            }
                        }
                    }
                }
                catch (e) {
                    // setShow(true)
                    // setTitle("No GPS data available")
                    // setType("danger")
                }

            })
            .catch(function (error) {
                console.log(error);
            });
        setLoader(false)
    }

    const onShowTransitData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code,
            consignee_code: params.data.consignee_code
        }
        redirectURL.post('/consignments/transitdelay', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: transitdelaycols,
                            defaultColDef: {
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowStoppagesData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code
        }
        redirectURL.post('/consignments/enroutes', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: stoppagescols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowOverspeedingData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_code: params.data.consignment_code
        }
        redirectURL.post('/consignments/overspeed', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: overspeedcols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowNightDrivingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: nightdrivingcols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let nightdriving = []
                redirectURL.post('/consignments/nightdriving', {
                    consignment_code: params.data.consignment_code,
                    gate_out_time: params.data.gate_out_time,
                    truck_no: params.data.truck_no
                })
                    .then((response) => {
                        //console.log("Step 1 ",response.data)
                        nightdriving = response.data;
                        params.successCallback(nightdriving);
                        //console.log("Step 2 ",response.data)

                    });
            },
        })
    }

    const onShowLoadingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: [

                    {
                        headerName: "Gate In Time",
                        field: "gate_in_time",
                        width: 180,
                        resizable: true,
                        valueGetter: function (params) {
                            if (params.data.gate_in_time) {
                                return params.data.gate_in_time;
                            }
                            else {
                                return "NA"
                            }

                        }
                    },
                    {
                        headerName: "Gate Out Time",
                        field: "gate_out_time",
                        width: 180,
                        resizable: true,
                        valueGetter: function (params) {
                            if (params.data.gate_out_time) {
                                return params.data.gate_out_time;
                            }
                            else {
                                return "NA"
                            }
                        }
                    },
                    {
                        headerName: "Loading Time",
                        field: "loading_time",
                        width: 180,
                    }
                ],
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                if (params.data.gate_in_time != undefined) {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.gate_in_time);
                    var gdate1 = new Date(params.data.gate_in_time);
                    var fromDate = g1;
                    var secondsgate1 = moment.parseZone(new Date(params.data.gate_in_time)).format("x")
                }
                else {

                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.inside_fence);
                    var gdate1 = new Date(params.data.inside_fence);
                    var fromDate = g1;
                    var secondsgate1 = moment.parseZone(new Date(params.data.inside_fence)).format("x")

                }
                if (params.data.gate_out_time != undefined) {
                    var g2 = getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
                    var gdate2 = new Date(params.data.gate_out_time);
                    var toField = getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
                    var secondsgate2 = moment.parseZone(new Date(params.data.gate_out_time)).format("x")
                }
                else {
                    var c = new Date();
                    var todaydate = moment(new Date(c)).format("x");
                    var g2 = getHyphenDDMMMYYYYHHMM(todaydate);
                    var gdate2 = new Date(todaydate);
                    var toField = getHyphenDDMMMYYYYHHMM(new Date());
                    var secondsgate2 = todaydate

                }

                var total = secondsgate2 - secondsgate1;
                var diffMs = total;
                var diffDays = Math.ceil(diffMs / 86400000); // days
                var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = parseInt(((diffMs % 86400000) % 3600000) / 60000);
                let loadingTimeDifference = null;
                var dataarr = []
                dataarr.push({
                    "gate_in_time": fromDate,
                    "gate_out_time": toField,
                    "loading_time": secondsToString(diffMs / 1000)
                })
                params.successCallback(dataarr);
            },
        })
    }

    const onShowUnloadingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: unloadingcols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                if (params.data.locked_dealer_reported == undefined) {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.first_dealer_reported);
                    var fromField = g1;
                }
                else {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.locked_dealer_reported);
                    var fromField = g1;
                }
                if (params.data.left_dealer_marked == undefined) {
                    var c = new Date();
                    var todaydate = c;
                    var g2 = getHyphenDDMMMYYYYHHMM(todaydate);
                    var toField = g2;
                }
                else {
                    var g2 = getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked);
                    var toField = g2;
                }
                var fstr = fromField.split("-");
                var gdate1 = new Date(fromField);
                var gdate2 = new Date(toField);
                var frmd = gdate1.getTime();
                var tod = gdate2.getTime();
                var total = tod - frmd;
                var diffMs = total;
                var diffDays = Math.floor(diffMs / 86400000); // days
                var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = parseInt(((diffMs % 86400000) % 3600000) / 60000);
                var dataarr = []
                let loadingTimeDifference = null;
                loadingTimeDifference = secondsToString(diffMs / 1000)
                dataarr.push({
                    "from_date": fromField,
                    "to_date": toField,
                    "unloading_time": loadingTimeDifference
                })
                params.successCallback(dataarr);
            },
        })
    }

    const onShowNoGPSData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: nogpscols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let nogpsrecords = []
                redirectURL.post('/consignments/nogpsdata', {
                    consignment_code: params.data.consignment_code,
                    truck_no: params.data.truck_no
                })
                    .then((response) => {
                        nogpsrecords = response.data;
                        params.successCallback(nogpsrecords);

                    });
            },
        })
    }
    // useEffect(()=>{

    // },[])
    const fragmentData = (resp) => {
        console.log(resp, "uiconsignments1");
        // let active_trips = resp.filter(e => { 
        //     if(parseInt(e.lr_no_updated) === 1 && (e.consignment_status == "In Transit"  || e.consignment_status == "Out For Delivery" || e.consignment_status == "Booked" || e.consignment_status == "Dispatched from Source")){
        //         return true
        //     }
        // })
        let active_trips = resp;
        let completed_trips = resp.filter(e => (e.consignment_status == "Delivered" || e.consignment_status == 6 || e.consignment_status == 7))
        let inactive_trips = resp.filter(e => (!e.lr_no_updated || e.consignment_status === "" || e.consignment_status === null || e.consignment_status === "Invalid Docket") );

        let active_consignments = []
        let active_transit_delay = []
        let active_stoppages = []
        let active_in_transit = []
        let active_out_for_delivery = []
        let active_tracking_na = []
        let active_accidents = []
        let active_trip_deviations = []
        let active_loadingdelay = []
        let active_unloadingdelay = []
        let active_no_gps_data = []
        let active_no_gps_data_lifetime = []

        let completed_consignments = []
        let completed_transit_delay = []
        let completed_stoppages = []
        let completed_accidents = []
        let completed_trip_deviations = []
        let completed_loadingdelay = []
        let completed_unloadingdelay = []
        let completed_no_gps_data = []
        let completed_no_gps_data_lifetime = []
        let completed_delivered = [];
        let completed_on_time = [];
        let completed_delayed = [];

        let all_consignments = [];
        let all_in_transit = [];
        let all_out_for_delivery = [];
        let all_delivered = [];
        let all_tracking_na = [];
        let all_undelivered = [];
        let all_cancelled = [];
        let all_no_data = [];

        let pending_on_time = [];
        let pending_delayed = [];
        let pending_no_data = [];
        
        let transit_delay = []
        let stoppages = []
        let accidents = []
        let trip_deviations = []
        let loading_delay = []
        let unloading_delay = []
        let no_gps_data = []
        let no_gps_data_lifetime = []

        let in_transit = [];
        let picked_up = [];
        let out_for_delivery = [];
        let delivered = [];
        let tracking_na = [];
        let undelivered = [];
        let cancelled = [];
        let no_data = [];
        // let overspeeding = []
        // let night_driving = []
        // let completed_overspeeding = []
        // let completed_night_driving = []
        // let active_overspeeding = []
        // let active_night_driving = []
        active_trips.map(each => {
            if (each.hasOwnProperty("consignment_status") && (each.consignment_status === "Booked" || each.consignment_status === "Dispatched from Source")){
                picked_up.push(each);
            }
            if (each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no")) && (each.consignment_status === "In Transit" || each.consignment_status === "Dispatched from Source")){
                active_in_transit.push(each);
            }
            if(each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no")) && each.consignment_status === "Out For Delivery"){
                active_out_for_delivery.push(each);
            }
            if (each.hasOwnProperty("last_process_on") && each.consignment_status.toLowerCase() !== "delivered") {
                const lastProcessOnDate = new Date(each.last_process_on);
                const today = new Date();
                const diffInMs = today.getTime() - lastProcessOnDate.getTime();
                const diffInDays = diffInMs / (1000 * 3600 * 24);
                if (diffInDays > 1) {
                  active_tracking_na.push(each);
                }
            }
            if (each.hasOwnProperty("transit_delay") && (each.hasOwnProperty("lr_no"))  && each.transit_delay > 0) {
                active_transit_delay.push(each)
            }
            if (each.hasOwnProperty("enroute_exception") && (each.hasOwnProperty("lr_no"))  && each.enroute_exception == 1) {
                active_stoppages.push(each)
            }
            if (each.hasOwnProperty("accident_exception") && (each.hasOwnProperty("lr_no"))  && each.accident_exception == 1) {
                active_accidents.push(each)
            }
            if (each.hasOwnProperty("tpt_deviation_status") && (each.hasOwnProperty("lr_no"))  && each.tpt_deviation_status == 1) {
                active_trip_deviations.push(each)
            }
            if (each.hasOwnProperty("loading_delay_exception") && (each.hasOwnProperty("lr_no"))  && each.loading_delay_exception == 1) {
                active_loadingdelay.push(each)
            }
            if (each.hasOwnProperty("unloading_delay_exception") && (each.hasOwnProperty("lr_no"))  && each.unloading_delay_exception == 1) {
                active_unloadingdelay.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && (each.hasOwnProperty("lr_no"))  && each.no_gps_data == 1) {
                active_no_gps_data.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && (each.hasOwnProperty("lr_no"))  && each.no_gps_data == 0) {
                active_no_gps_data_lifetime.push(each)
            }
            // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
            //     active_overspeeding.push(each)
            // }
            // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
            //     active_night_driving.push(each)
            // }
        })
        completed_trips.map(each => {
            if (each.hasOwnProperty("transit_delay") && (each.hasOwnProperty("lr_no"))  && each.transit_delay > 0) {
                completed_transit_delay.push(each)
            }
            if(each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no"))  && (each.consignment_status === "arrived_at_destination" || each.consignment_status === "Delivered")){
                completed_delivered.push(each);
            }
            if(each.hasOwnProperty("on_time_status") && (each.hasOwnProperty("lr_no"))  && each.on_time_status === 0){
                completed_delayed.push(each);
            }
            if(each.hasOwnProperty("on_time_status") && (each.hasOwnProperty("lr_no"))  && each.on_time_status === 1){
                completed_on_time.push(each);
            }
            // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
            //     completed_overspeeding.push(each)
            // }
            // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
            //     completed_night_driving.push(each)
            // }
            if (each.hasOwnProperty("enroute_exception") && (each.hasOwnProperty("lr_no"))  && each.enroute_exception == 1) {
                completed_stoppages.push(each)
            }
            if (each.hasOwnProperty("accident_exception") && (each.hasOwnProperty("lr_no"))  && each.accident_exception == 1) {
                completed_accidents.push(each)
            }
            if (each.hasOwnProperty("tpt_deviation_status") && (each.hasOwnProperty("lr_no"))  && each.tpt_deviation_status == 1) {
                completed_trip_deviations.push(each)
            }
            if (each.hasOwnProperty("loading_delay_exception") && (each.hasOwnProperty("lr_no")) && each.loading_delay_exception == 1) {
                completed_loadingdelay.push(each)
            }
            if (each.hasOwnProperty("unloading_delay_exception") && (each.hasOwnProperty("lr_no"))  && each.unloading_delay_exception == 1) {
                completed_unloadingdelay.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && (each.hasOwnProperty("lr_no"))  && each.no_gps_data == 1) {
                completed_no_gps_data.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && (each.hasOwnProperty("lr_no"))  && each.no_gps_data == 0) {
                completed_no_gps_data_lifetime.push(each)
            }
        })
        resp.map(each => {
            if (each.hasOwnProperty("transit_delay") && (each.hasOwnProperty("lr_no"))  && each.transit_delay > 0) {
                transit_delay.push(each)
            }
            if (each.hasOwnProperty("consignment_status") && (each.consignment_status === "Booked" || each.consignment_status === "Dispatched from Source")){
                picked_up.push(each);
            }
            if (each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no"))  && (each.consignment_status === "In Transit" || each.consignment_status === "Dispatched from Source")){
                all_in_transit.push(each);
            }
            if(each.hasOwnProperty("consignment_status") && each.consignment_status === "Out For Delivery"){
                all_out_for_delivery.push(each);
            }
            if(each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no"))  && (each.consignment_status === "arrived_at_destination" || each.consignment_status === "Delivered")){
                all_delivered.push(each);
            }
            
            if (each.hasOwnProperty("last_process_on") && each.consignment_status.toLowerCase() !== "delivered") {
                const lastProcessOnDate = new Date(each.last_process_on);
                const today = new Date();
                const diffInMs = today.getTime() - lastProcessOnDate.getTime();
                const diffInDays = diffInMs / (1000 * 3600 * 24);
                if (diffInDays > 1) {
                  all_tracking_na.push(each);
                }
            }
            if(each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no"))  && each.consignment_status === "Undelivered"){
                all_undelivered.push(each);
            }
            if(each.hasOwnProperty("consignment_status") && (each.hasOwnProperty("lr_no"))  && each.consignment_status === "Cancelled"){
                all_cancelled.push(each);
            }
            // if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
            //     overspeeding.push(each)
            // }
            // if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
            //     night_driving.push(each)
            // }
            if (each.hasOwnProperty("enroute_exception") && (each.hasOwnProperty("lr_no"))  && each.enroute_exception == 1) {
                stoppages.push(each)
            }
            if (each.hasOwnProperty("accident_exception") && (each.hasOwnProperty("lr_no"))  && each.accident_exception == 1) {
                accidents.push(each)
            }
            if (each.hasOwnProperty("tpt_deviation_status") && (each.hasOwnProperty("lr_no"))  && each.tpt_deviation_status == 1) {
                trip_deviations.push(each)
            }
            if (each.hasOwnProperty("loading_delay_exception") && (each.hasOwnProperty("lr_no"))  && each.loading_delay_exception == 1) {
                loading_delay.push(each)
            }
            if (each.hasOwnProperty("unloading_delay_exception") && (each.hasOwnProperty("lr_no"))  && each.unloading_delay_exception == 1) {
                unloading_delay.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && (each.hasOwnProperty("lr_no"))  && each.no_gps_data == 1) {
                no_gps_data.push(each)
            }
            if (each.hasOwnProperty("no_gps_data") && (each.hasOwnProperty("lr_no"))  && each.no_gps_data == 0) {
                no_gps_data_lifetime.push(each)
            }
        })

        setActiveTrips({
            all: [...active_in_transit, ...active_out_for_delivery, ...active_tracking_na],
            picked_up: picked_up,
            in_transit: active_in_transit,
            out_for_delivery: active_out_for_delivery,
            tracking_na: active_tracking_na,
            transit_delays: active_transit_delay,
            // overspeeding: active_overspeeding,
            // night_driving: active_night_driving,
            stoppages: active_stoppages,
            accidents: active_accidents,
            trip_deviations: active_trip_deviations,
            loading_delay: active_loadingdelay,
            unloading_delay: active_unloadingdelay,
            no_gps_data: active_no_gps_data,
            no_gps_data_lifetime: active_no_gps_data_lifetime
        })
        setCompletedTrips({
            all: [...completed_delivered, ...completed_on_time, ...completed_delayed],
            delivered: completed_delivered,
            on_time: completed_on_time,
            delayed: completed_delayed,            
            transit_delays: completed_transit_delay,
            // overspeeding: completed_overspeeding,
            // night_driving: completed_night_driving,
            stoppages: completed_stoppages,
            accidents: completed_accidents,
            trip_deviations: completed_trip_deviations,
            loading_delay: completed_loadingdelay,
            unloading_delay: completed_unloadingdelay,
            no_gps_data: completed_no_gps_data,
            no_gps_data_lifetime: completed_no_gps_data_lifetime
        })
        setAllTrips({
            all: [...all_in_transit, ...all_out_for_delivery, ...all_delivered, ...all_tracking_na, ...all_undelivered, ...all_cancelled],
            picked_up: picked_up,
            in_transit: all_in_transit,
            out_for_delivery: all_out_for_delivery,
            delivered: all_delivered,
            tracking_na: all_tracking_na,
            undelivered: all_undelivered,
            cancelled: all_cancelled,
            transit_delays: transit_delay,
            // overspeeding: overspeeding,
            // night_driving: night_driving,
            stoppages: stoppages,
            accidents: accidents,
            trip_deviations: trip_deviations,
            loading_delay: loading_delay,
            unloading_delay: unloading_delay,
            no_gps_data: no_gps_data,
            no_gps_data_lifetime: no_gps_data_lifetime
        })
        setInactiveTrips({
            all: inactive_trips,
            on_time: pending_on_time,
            delayed: pending_delayed,
            no_data: pending_no_data
        })

        setCountersActive({
            consignments: active_in_transit.length+active_out_for_delivery.length+active_tracking_na.length,
            in_transit: active_in_transit.length,
            out_for_delivery: active_out_for_delivery.length,
            tracking_na: active_tracking_na.length,
            // undelivered: undelivered.length,
            transit_delays: active_transit_delay.length,
            // overspeeding: active_overspeeding.length,
            // night_driving: active_night_driving.length,
            stoppages: active_stoppages.length,
            accidents: active_accidents.length,
            trip_deviations: active_trip_deviations.length,
            loading_delay: active_loadingdelay.length,
            unloading_delay: active_unloadingdelay.length,
            no_gps_data: active_no_gps_data.length,
            no_gps_data_lifetime: active_no_gps_data_lifetime.length
        })
        setCountersCompleted({
            consignments: completed_delivered.length + completed_on_time.length + completed_delayed.length,
            delivered: completed_delivered.length,
            on_time: completed_on_time.length,
            delayed: completed_delayed.length,
            transit_delays: completed_transit_delay.length,
            // overspeeding: completed_overspeeding.length,
            // night_driving: completed_night_driving.length,
            stoppages: completed_stoppages.length,
            accidents: completed_accidents.length,
            trip_deviations: completed_trip_deviations.length,
            loading_delay: completed_loadingdelay.length,
            unloading_delay: completed_unloadingdelay.length,
            no_gps_data: completed_no_gps_data.length,
            no_gps_data_lifetime: completed_no_gps_data_lifetime.length
        })
        setCountersAll({
            consignments: all_in_transit.length + all_out_for_delivery.length+all_delivered.length+all_tracking_na.length+all_undelivered.length+all_cancelled.length,
            picked_up: picked_up.length,
            in_transit: all_in_transit.length,
            out_for_delivery: all_out_for_delivery.length,
            delivered: all_delivered.length,
            tracking_na: all_tracking_na.length,
            undelivered: all_undelivered.length,
            cancelled: all_cancelled.length,
            transit_delays: transit_delay.length,
            // overspeeding: overspeeding.length,
            // night_driving: night_driving.length,
            stoppages: stoppages.length,
            accidents: accidents.length,
            trip_deviations: trip_deviations.length,
            loading_delay: loading_delay.length,
            unloading_delay: unloading_delay.length,
            no_gps_data: no_gps_data.length,
            no_gps_data_lifetime: no_gps_data_lifetime.length
        })
        setCountersInactive({
            consignments: inactive_trips.length,
            delayed: pending_delayed.length,
            on_time: pending_on_time.length,
            no_data: pending_no_data.length
        })
        console.log(activeTrips,"BBBBBBB");
        if (window.location.pathname == "/activeptlconsignments") {
            setRowData([...active_in_transit, ...active_out_for_delivery, ...active_tracking_na])
            setTabName(tabOptions[0])
        }
        else if (window.location.pathname == "/deliveredptlconsignments") {
            setRowData([...completed_delivered, ...completed_on_time, ...completed_delayed])
            setTabName(tabOptions[1])
        }
        else if (window.location.pathname.trim() == "/allptlconsignments") {
            setRowData([...all_in_transit, ...all_out_for_delivery, ...all_delivered, ...all_tracking_na, ...all_undelivered, ...all_cancelled])
            setTabName(tabOptions[2])
        }
        else if (window.location.pathname == "/inactiveptlconsignments") {
            setRowData(inactive_trips)
            setTabName(tabOptions[3])
        }
    }

    const loadConsignmentsData = () => {
        console.log("getconsignments")
        redirectURL.post("consignments/getCourierLRConsignments")
            .then(resp => {
                if(resp.data.status === "success"){    
                    console.log(resp.data.consignments,"in consignments")
                    fragmentData(resp.data.consignments)
                }
            })
            .catch(err => console.log(err))
    }
    const getTruckConsignments = async (e) => {
        setLoader(true)
        setOverlay("show-m")
        e.preventDefault();
        let params = {}
        if(searchType && searchType.value === "truck_no"){
            params.truck_no = searchVehicle.value;
            params.tabType = tabName.value;
        } else if( searchType && searchType.value === "lr_no"){
            params.lr_no = lrNo.value;
            params.tabType = tabName.value;
        } else {
            params.invoice_no = searchInvoice.value;
            params.tabType = tabName.value;
        }
        console.log(params,"leftboxSubmitParams");
        await redirectURL.post("consignments/filterCourierLRConsignments", params)
            // .then(resp => {
            //     fragmentData(resp)
            // })
            // .catch(err => console.log(err))
            .then(resp => {
                console.log(resp,"ffffffffffffffffff")                    
                if(resp.data.consignments.length > 0){
                    fragmentData(resp.data.consignments)
                    setSearchVehicle({value:"", label:""})
                    setOverlay("show-n")
                }else {
                    setShow(true)
                    setTitle("No Records Found")
                    setType("danger")
                }
            })
            .catch(err => console.log(err))
    }
    const saveConsignments = async (e) => {
        e.preventDefault();
        if (gridApi.current) {
            gridApi.current.stopEditing();
            const gridRowData = [];
            gridApi.current.forEachNode((node) => {
                console.log(node.data,"LLLLLLLLLLLLLLLL");
                if (node.data.invoice_no == "" || node.data.invoice_time == "" || node.data.entity == "" || node.data.consigner_name == "" || node.data.destination_pincode == "" || node.data.total_cbm == "" || node.data.total_weight == "" || node.data.courier_partner == "" || node.data.vehicle_type == undefined || node.data.truck_no == undefined || node.data.dispatch_date == undefined || node.data.shipment_mode == undefined || node.data.eway_bill_no == undefined || node.data.no_of_boxes == undefined || node.data.customer_mail_id == undefined) {
                    setShow(true)
                    setTitle("Please fill the required fields")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if (!(node.data.invoice_no)) {
                    setShow(true)
                    setTitle("Please give a valid invoice no")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.consigner_name){
                    setShow(true)
                    setTitle("Please give a customer name")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.destination_pincode){
                    setShow(true)
                    setTitle("Please give a destination pincode")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.total_cbm){
                    setShow(true)
                    setTitle("Please give a total CBM")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.total_weight){
                    setShow(true)
                    setTitle("Please give a total weight")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.courier_partner){
                    setShow(true)
                    setTitle("Please give a courier partner")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.vehicle_type){
                    setShow(true)
                    setTitle("Please give a vehicle type")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.truck_no){
                    setShow(true)
                    setTitle("Please give a truck no")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if ((!moment(node.data.dispatch_date, "DD-MM-YY", true).isValid())) {
                    setShow(true)
                    setTitle("Please give a valid Dispatch Date (DD-MM-YY)")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.shipment_mode){
                    setShow(true)
                    setTitle("Please give a mode of shipment")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.eway_bill_no){
                    setShow(true)
                    setTitle("Please give a E-Way Bill")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.no_of_boxes){
                    setShow(true)
                    setTitle("Please give no of boxes")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }
                else if(!node.data.customer_mail_id){
                    setShow(true)
                    setTitle("Please give customer mail")
                    setType("danger")
                    gridApi.current.refreshCells()
                    return
                }

                // else if(!node.data.total_weight){
                //     setShow(true)
                //     setTitle("Please give a total weight")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (isNaN(node.data.quantity)) {
                //     setShow(true)
                //     setTitle("Please give a valid quantity")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.execution_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Execution Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.expected_date, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Expected Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (!moment(node.data.expected_return_to_plant_date, "YYYY-MM-DD HH:mm:ss").isValid()) {
                //     setShow(true)
                //     setTitle("Please give a valid Expected Return to Plant Date (YYYY-MM-DD HH:mm:ss)")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                // else if (previousData.some(e => ((e.order_number == node.data.order_number) && (e.fo_number == node.data.fo_number)))) {
                //     setShow(true)
                //     setTitle("Order number and FO number combination already exist for previous consignments")
                //     setType("danger")
                //     gridApi.current.refreshCells()
                //     return
                // }
                else
                    gridRowData.push(node.data)
            })
            console.log(gridRowData,"gridRowData");
            if (gridRowData.length > 0) {
                await redirectURL.post("/bulkUploadConsignments", { consignments: gridRowData, email: "" })
                    .then(response => {
                        if (response.data.status == "Success") {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("success")
                            setLoader(false)
                            setBulkUploadModal(false)
                            setModalLoadData([])
                            loadConsignmentsData()
                            setBulkUploadModal.bulkPrioritySlide("")
                            setBulkUploadModal.overly('show-n')
                            setOverlay("show-n")
                        }
                        else {
                            setShow(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoader(false)
                        }
                    })
                    .catch(err => console.log(err))
            }
        }
    }
    const onClickDeliveredSubmit = (e)=>{
        e.preventDefault();
        setOverlay("show-m")
        setLoadShow('show-m')
        let updatedDeliveredData = {
            lr_no: Dselected_row.lr_no,
            invoice_no: Dselected_row.invoice_no,
            consignment_status: form2Details.selectedStatus.value,
            delivery_station: form2Details.event_location,
            delivery_datetime: form2Details.delivered_date
        }
        if(ableRemark){
            updatedDeliveredData.remark = form2Details.remark
        }
        console.log(updatedDeliveredData,"updatedDeliveredData");
        redirectURL.post('/consignments/updateDeliveryDetails', updatedDeliveredData).then((resp) => {
            console.log(resp.data, '176')
            if (resp.data.status == 'Success') {
                setTitle(resp.data.message);
                setShow(true)                
                setType("success");
                setLoadShow('show-n');
                setOverlay('show-n');
                setshowAddForm2('');
                setForm2Details({
                    event_status: [
                      { label: 'InTransit', value: 'InTransit' }, 
                      { label: 'Near Destination', value: 'near_destination' },
                      { label: 'Reached Destination', value: 'reached_destination' },
                      { label: 'Delivered', value: 'delivered' },
                      { label: 'UnDelivered', value: 'Undelivered' },
                    ],
                    selectedStatus: {value: 'InTransit', label: 'InTransit'},
                    event_location: "",
                    remark: "",
                    delivered_date:'',
                })
                setDselected_row({})
                window.location.reload();
            }
            else{
                setShow(true)
                setTitle(resp.data.message)
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n');
                deselectAllRows();
                setshowAddForm2('');
                setForm2Details({
                    event_status: [
                      { label: 'InTransit', value: 'InTransit' }, 
                      { label: 'Near Destination', value: 'near_destination' },
                      { label: 'Reached Destination', value: 'reached_destination' },
                      { label: 'Delivered', value: 'delivered' },
                      { label: 'UnDelivered', value: 'Undelivered' },
                    ],
                    selectedStatus: {value: 'InTransit', label: 'InTransit'},
                    event_location: "",
                    remark: "",
                    delivered_date:'',
                })
                setDselected_row({})
            }
        })
    }
    const changeHandleDate1 = (date) => {
        setForm2Details((prev) => ({
        ...prev,
        delivered_date: date,
        }))
    
    };
    const onConfirm = () => {
        setShow(false);
        setLoader(false)
        if (reloadPage.current) {
            window.location.reload()
        }
    };
    const onClickShowForm=()=> {
        setOverlay("show-m")
        setSliderCreateConsignmentTranslate("slider-translate-30p")
	}
    const onSelectLrStatus = (e) => {
        setmanualUploadDetails(prev => ({
            ...prev,
            lr_status: { label: e.label, value: e.value }
        }))
    }
    const changeHandler = (event) => {
        const { name, value } = event.target;
        if (name === "driver_mobile_num" || name === "transit_days") {
            if (value !== "" && value !== undefined) {
                if (value > 0) {
                    setFormData(prevState => ({
                        ...prevState,
                        [name]: value.replace(/\D/g, '')
                    }));
                }
            } else {
                setFormData(prevState => ({
                    ...prevState,
                    [name]: value.replace(/\D/g, '')
                }));
            }
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };
    // const onClickHideAll=()=> {
	// 	var uploadfilebulk = $("#uploadfile").val(null)
	// 	this.setState({
	// 		loadshow: 'show-n',
	// 		overly: 'show-n',
	// 		slideuploadeway: '',
	// 		sliderRouteTranslate: '',
	// 		sliderSegmentTranslate: "",
	// 		tabsliderTranslate: '',
	// 		sliderTranslatesidebar: '',
	// 		sliderForceCloseTranslate: '',
	// 		sliderChangeDriverDetails:'',
	// 		sliderCommentTranslate: "",
	// 		bulkPrioritySlide: "",
	// 		sliderCreateConsignmentTranslate: "",
	// 		sliderRso:"",
	// 		sliderSimConsent:"",
	// 		uploadfilebulk:uploadfilebulk
	// 	});

	// }
    const onGridReady = useCallback((params) => {
        gridApi.current = params.api
    }, []);

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const onClickHideManualUpload = () => {
        setshowAddForm("");
        setOverlay("show-n");
        setmanualUploadDetails((prev) => ({
          ...prev,
          lr_no: "",
          lr_status: {label:"",value:''},
        // lr_status:'',
          location: "",
          arrival_time: "",
          invoice_no: "",
        }));
      };
      const onClickHideManualUpload1 = () => {
        setshowAddForm("");
        setOverlay("show-n");
        setmanualUploadDetails1((prev) => ({
          ...prev,
          invoice_no:'',
          lr_no: "",
        }));
      };
    //   const changeHandleDate = (e) => {
    //     var d = moment(e);
    //     var formattedDate = d.format("DD-MM-YYYY HH:MM:SS" );
    //     return formattedDate;
    //   };
      const changeHandleDate = (date) => {
            // const formattedDate = moment(date).format("DD-MM-YYYY HH:mm:ss");
            setmanualUploadDetails((prev) => ({
            ...prev,
            arrival_time: date,
            }))
        
    };
    

      const onsubmitdata = (e) => {
        e.preventDefault()
        var data = {
            invoice_no: manualUploadDetails1.invoice_no,
            consigner_name: manualUploadDetails1.consigner_name,
            consignee_city:manualUploadDetails1.consignee_city,
            consignee_state: manualUploadDetails1.consignee_state,
            consignee_pincode:manualUploadDetails1.consignee_pincode,
            total_weight:manualUploadDetails1.total_weight
        }
        console.log(data, 'data')
        redirectURL.post('/consignments/updatePTLConsignments', data).then((resp) => {
            console.log(resp.data, '176')
            if (resp.data.message == 'success') {
                setShow(true)
                setTitle("PTL Consignments has been successfully updated!")
                setType("success")
                setLoadShow('show-n')
                setOverlay('show-n')
                setshowAddForm('')
                loadConsignmentsData()
                setmanualUploadDetails1({
                    lr_no: "",
                    invoice_no: selected_row.invoice_no || '',
                    consigner_name: "",
                    consignee_city: "",
                    consignee_state: "",
                    consignee_pincode: "",
                    total_weight: ""
                })
            }
            else{
                setShow(true)
                setTitle("Please Upload Valid Details")
                setType("danger")
                setLoadShow('show-n')
                setOverlay('show-n')
                setmanualUploadDetails1({
                    lr_no: "",
                    invoice_no: selected_row.invoice_no || '',
                    consigner_name: "",
                    consignee_city: "",
                    consignee_state: "",
                    consignee_pincode: "",
                    total_weight: ""
                })
            }
        })
        // }
        // else{
        //     setshow(true)
        //     setbasicTitle("Please Select Transporter")
        //     setbasicType("danger")
        //     setloadshow('show-n')
        //     setoverly('show-n')
        // }
        setmanualUploadDetails((prev) => ({
            ...prev,
            lr_no: "",
            lr_status: {label:"",value:''},
          // lr_status:'',
            location: "",
            arrival_time: "",
            invoice_no: "",
          }));

    }  
    const redirectToFtl = () => {
        window.location.href = '/activeftlconsignments';
    }
    const onsubmitdata1 = (e) => {
        e.preventDefault()
        var data = {
            lr_no: manualUploadDetails1.lr_no,
          
            invoice_no:manualUploadDetails1.invoice_no,
            shipment_id:selected_row.shipment_id
        }
        console.log(data, 'data')
        // var rparams = {
        //     data: data,
        //     // row:selected_row
        // }
        // if(manualUploadDetails.transporter.value!='' && manualUploadDetails.transporter.value!=undefined){
            redirectURL.post('/consignments/updateLRno', data).then((resp) => {
                console.log(resp.data, '176')
                if (resp.data.status == 'Success') {
                    setShow(true)
                    setTitle("LR No has been successfully updated!")
                    setType("success")
                    setLoadShow('show-n')
                    setOverlay('show-n')
                    setshowAddForm('')
                }
                else{
                    setShow(true)
                    setTitle("Please Upload Valid Details")
                    setType("danger")
                    setLoadShow('show-n')
                    setOverlay('show-n')
                }
            })
        // }
        // else{
        //     setshow(true)
        //     setbasicTitle("Please Select Transporter")
        //     setbasicType("danger")
        //     setloadshow('show-n')
        //     setoverly('show-n')
        // }
        setmanualUploadDetails1((prev) => ({
            ...prev,
            lr_no: "",
            invoice_no: "",
          }));

    }  
    const onSubmitLrUpdateForm = (e) => {
        e.preventDefault()
        deselectAllRows();
        console.log(manualUploadDetails,"ZZZZZZZZZZZZZZZZZ", showAddForm);
        const extractedInvoices = selectedInvoicetoUpdateLr.map(e => e.value)
        var data = {
            lr_no: showAddForm === "slider-translate-30p"? Number(manualUploadDetails.lr_no) :Number(updatelrNo.trim()),
            invoice_no: showAddForm === "slider-translate-30p"? [manualUploadDetails.invoice_no] :extractedInvoices,
        }
        console.log(data, 'data2222')
        if(showAddForm === "slider-translate-30p" || ((invoiceSelected && invoiceSelected.value!='') && (updatelrNo!=undefined && updatelrNo!="" ))){
            redirectURL.post('/consignments/updateLRno', data).then((resp) => {
                // console.log(resp.data, '176')
                if (resp.data.status == 'Success') {
                    setTitle("LR No has been successfully updated!");
                    setShow(true)
                    if(selectedRows.length>1){
                        setTitle(`LR No's has been successfully updated!`);
                    } else {
                        setTitle("LR No has been successfully updated!");
                    }
                    
                    setType("success");
                    setLoadShow('show-n');
                    setOverlay('show-n');
                    setShowUpdateLrForm('');
                    deselectAllRows();
                    setUpdateLrNo('');
                    setSelectInvoicesToUpdate([]);
                    window.location.reload();
                }
                else{
                    setShow(true)
                    setTitle("Please Upload Valid Details")
                    setType("danger")
                    setLoadShow('show-n')
                    setOverlay('show-n');
                    setShowUpdateLrForm('');
                    deselectAllRows();
                    setUpdateLrNo('');
                    setSelectInvoicesToUpdate([]);
                }
            })
        }
        else if(!invoiceSelected){
            setShow(true)
            setTitle("Please Selected Invoice")
            setType("danger")
            setLoadShow('show-n')
            setOverlay('show-n')
        } else {
            setShow(true)
            setTitle("Please Enter Lr'no")
            setType("danger")
            setLoadShow('show-n')
            setOverlay('show-n')
        }
        
        setShowUpdateLrForm('');
        deselectAllRows();
        setUpdateLrNo('');
        setSelectInvoicesToUpdate([]);
    }  

    var filterClassName = "form-group col-xl-12 col-lg-12";
    return (
        <div>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <Modal
                onHide={closeForceCloseModal}
                dialogClassName="my-modal"
                show={forcecloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Force Close</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeForceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={formForceCloseHandler}>
                            <div className="col-xl-12 col-lg-12">
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Force Close
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForceClose}
                                    onChange={e => setReasonForceClose(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={closeCancelModal}
                dialogClassName="my-modal"
                show={cancelModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Disable Shipment</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeCancelModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <div>
                        <form onSubmit={cancelFormCloseHandler}>
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label className="reason">LR No</label>
                                <input type="text" name="reason" autoComplete="off" class="form-control" id="lrno" value={rownode.lr_no} />                                
                            </div>
                            <div className='col-xl-12 col-lg-12' style={{marginBottom:"20px"}}>
                                <label>Selected Invoices </label>
                                <Select 
                                    closeMenuOnSelect={false}
                                    value={lrNoOption}
                                    isMulti={true}
                                    className="border-radius-0"
                                    style={{ borderRadius: "0px" }}
                                    required 
                                />
                            </div>
                            <div className="col-xl-12 col-lg-12" style={{marginBottom:"20px"}}>
                                <label style={{ color: "#EB1D54", fontSize: "13px", fontFamily: "Inter" }}>*</label>
                                <label className="custom-label">
                                    Reason For Withdrawel
                                </label>
                                <textarea
                                    type="text"
                                    value={reasonForCancellation}
                                    onChange={e => setReasonForCancellation(e.target.value)}
                                    autoComplete="off"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div style={{ paddingTop: "2rem", display: "flex", justifyContent: "flex-end" }}>
                                <button type='submit' className='primary-button'>Submit</button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            <h1 className='title-heading mb-10p' style={{marginTop: "-18px"}}>PTL Consignments</h1>

            <div className='row col-xl-12 col-lg-12 justify-content-between'>
            <div>
                <button
                    onClick={(e) => { userClickedTab(e); setTabName(tabOptions[3]); setRowData(inactiveTrips.all); }}
                    id="inactive"
                    className={tabName.value === "inactive" ? "btn btn-info" : "btn"}
                    style={{ display: tabName.value === "inactive" ? "inline-flex" : "" }}
                >
                    Invoice Pending For LR Update
                </button>

                <button
                    onClick={(e) => { userClickedTab(e); setTabName(tabOptions[0]); setRowData(activeTrips.all); }}
                    id="active"
                    className={tabName.value === "active" ? "btn btn-info" : "btn"}
                    style={{ display: tabName.value === "active" ? "inline-flex" : "" }}
                >
                    Active
                </button>

                <button
                    onClick={(e) => { userClickedTab(e); setTabName(tabOptions[1]); setRowData(completedTrips.all); }}
                    id="completed"
                    className={tabName.value === "completed" ? "btn btn-info" : "btn"}
                    style={{ display: tabName.value === "completed" ? "inline-flex" : "" }}
                >
                    Delivered
                </button>

                <button
                    onClick={(e) => { userClickedTab(e); setTabName(tabOptions[2]); setRowData(allTrips.all); }}
                    id="all"
                    className={tabName.value === "all" ? "btn btn-info" : "btn"}
                    style={{ display: tabName.value === "all" ? "inline-flex" : "" }}
                >
                    All
                </button>
            </div>


                <div style={{ marginRight: "-36px" }}>
                    <a className={tabActive === "ptl" ? "tab-active" : ""}
                        aria-current="page"
                        onClick={redirectToFtl}
                        style={{
                            color: tabActive === "ptl" ? "#c81e27" : "inherit",
                            borderTop: "none",
                            borderLeft: "none",
                            borderRight: "none",
                            cursor: "pointer",
                            fontSize: "16px",
                            marginRight: "20px",
                            verticalAlign: "middle",
                            lineHeight: "40px"
                        }}
                    >
                        FTL
                        <i style={{ paddingLeft: "10px" }} className="fa fa-chevron-right"></i>
                    </a>
                    {(tabName.value === "active" || tabName.value === "inactive") && (
                        <button
                            title="Bulk Upload"
                            onClick={onClickOpenBulkUploadModal}
                            className={"float-right btn btn-warning mr-2"}
                            type="button"
                        >
                            <i className="fa fa-upload"></i>&nbsp;&nbsp;&nbsp;Upload Consignments
                        </button>
                    )}
                    <i className="icofont icofont-filter filter-styling" onClick={() => setFilterToggle(prev => !prev)}></i>
                </div>
            </div>

            <div className={filterToggle ? "filter-in" : "filter-out"}>
                {
                    filterToggle &&
                    <div className={filterToggle ? "row" : "row"}>
                        <div className={"col-xl-4 col-lg-4 "}>
                            <div className="card" style={filterCardStyle1}>
                                <div className="row card-body" style={{ padding: "10px 30px" }}>
                                    <form className="row" onSubmit={getTruckConsignments}>
                                        <div className={filterClassName}>
                                            <label>Select Type  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedFilter"
                                                value={searchType}
                                                onChange={e => setSearchType(e)}
                                                style={{ borderRadius: "0px" }}
                                                options={
                                                    tabName.value === "inactive" 
                                                    ? [
                                                        // { label: "Vehicle", value: "truck_no" },
                                                        { label: "Invoice No", value: "invoice_no" }
                                                      ] 
                                                    : [
                                                        // { label: "Vehicle", value: "truck_no" },
                                                        { label: "LR No", value: "lr_no" },
                                                        { label: "Invoice No", value: "invoice_no" }
                                                      ]
                                                }
                                                required />
                                        </div>
                                        {searchType.value === "truck_no" ?                                             
                                            <div className={filterClassName}>
                                                {/* <label className="reason">Vehicle No</label>
                                                <input type="text" name="reason" autoComplete="off" class="form-control" id="inputTruckConsignment" value={searchValue} onChange={e => setSeachValue(e.target.value)} /> */}

                                                <label>Vehicle No</label>
                                                <Select
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="selectedVehicle"
                                                    style={{ borderRadius: "0px" }}
                                                    value={searchVehicle}
                                                    onChange={e => setSearchVehicle(e)}
                                                    options={filteredvehicles}
                                                />
                                            </div>
                                        : ""}
                                        {searchType.value === "invoice_no" ?
                                            <div className={filterClassName}>
                                                <label>Invoice No</label>
                                                <Select
                                                    className="border-radius-0"
                                                    isMulti={false}
                                                    id="selectedInvoice"
                                                    style={{ borderRadius: "0px" }}
                                                    value={searchInvoice}
                                                    onChange={e => setSearchInvoice(e)}
                                                    options={filteredInvoices}
                                                />
                                            </div>                                        
                                        : ""}
                                        {searchType.value === "lr_no" ?  
                                            (tabName.value !== "inactive" ?                                      
                                                <div className={filterClassName}>
                                                    <label>LR No</label>
                                                    <Select
                                                        className="border-radius-0"
                                                        isMulti={false}
                                                        id="selectedLr"
                                                        style={{ borderRadius: "0px" }}
                                                        value={lrNo}
                                                        onChange={e => setLrNo(e)}
                                                        options={filteredLrnos}
                                                    />
                                                </div>                                                
                                            :
                                            ""
                                            ) 
                                        : ""}
                                        <div className='col-xl-12 col-lg-12'></div>
                                        <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                            <button type="submit" className="btn btn-success">Submit</button>
                                        </div>
                                        <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                            <button type="button" onClick={resetFilters} className="btn btn-warning">Reset</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className={"col-xl-8 col-lg-8"}>
                            <div className="card" style={filterCardStyle1}>
                                <div className="row card-body" style={filterCardStyle2}>
                                    <div className="row col-xl-12 col-lg-12" style={mnFilterClass}>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Select Consigner </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={searchConsigner}
                                                isMulti={true}
                                                className="border-radius-0"
                                                onChange={e => setSearchConsigner(e)}
                                                style={{ borderRadius: "0px" }}
                                                options={consignersList}
                                                required />

                                        </div>
                                        <div className="col-xl-4 col-lg-4 form-group">
                                            <div className="col-xl-12 col-lg-12"><label>From Date</label></div>
                                            <div className="col-xl-12 col-lg-12">
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={handleStartDateChange}
                                                    name="startDate"
                                                    className="datepicker-custom"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 form-group">
                                            <div className="col-xl-12 col-lg-12"> <label>To Date</label></div>
                                            <div className="col-xl-12 col-lg-12">
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={handleEndDateChange}
                                                    name="endDate"
                                                    className="datepicker-custom"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row col-xl-12 col-lg-12" style={{ marginLeft: "0px", padding: "0px" }}>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Consignee City</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedCity"
                                                style={{ borderRadius: "0px" }}
                                                value={searchCity}
                                                onChange={e => setSearchCity(e)}
                                                options={filterCities}
                                            />
                                        </div>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Consignee State</label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedState"
                                                style={{ borderRadius: "0px" }}
                                                value={searchState}
                                                onChange={e => setSearchStates(e)}
                                                options={filterStates}
                                            />
                                        </div>
                                        <div className="form-group col-xl-4 col-lg-4">
                                            <label>Transporter  </label>
                                            <Select
                                                className="border-radius-0"
                                                isMulti={false}
                                                id="selectedTransporter"
                                                style={{ borderRadius: "0px" }}
                                                value={searchTransporters}
                                                onChange={(e) => setSearchTransporters(e)}
                                                options={filterTransporters}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left", maxWidth:"77px" }}>
                                        <button type="button" className="btn btn-success" onClick={onGetConsignments}>Submit</button>
                                    </div>
                                    <div className="form-group col-xl-2 col-lg-2" style={{ textAlign: "left" }}>
                                        <button type="button" onClick={resetFilters1} className="btn btn-warning">Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className={"slide-r " + (bulkUploadModal.bulkPrioritySlide)} style={{ overflow: "auto" }}>
                <h3 className="subH">Bulk Upload Consignments
                    <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeBulkUploadModal} >X</span>
                </h3>

                <div className="slide-r-body" style={{ position: "relative" }}>
                    <div className="container-fluid">
                        <form method="POST" id="upform" className="theme-form">
                            <div className="col-xl-6 col-lg-6 form-group">
                                <label className="">Upload File</label>
                                <input type="file" name="uploadFile" id="bulkUploadCritical" onChange={changeFileHandler} className="form-control" required />
                            </div>
                        </form>
                        <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div className="form-group">
                                {/* <a className="btn btn-primary" href={require('../../assets/files/Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a> */}
                                {/* <a className="btn btn-primary" href={require('../../assets/files/PTL Legrand Autometrics Consignments Format.xlsx')} target="_blank">Sample Template</a> */}
                            </div>
                            <div className='form-group' style={{ marginRight: "8px" }}>
                                <div><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div> */}
                            </div>
                        </div>
                        <div className="ag-theme-balham mt-2" style={{ height: '58vh', width: '100%' }}>
                            <AgGridReact
                                columnDefs={columnDef}
                                rowData={modalloadData}
                                // rowData={rowData1}
                                defaultColDef={defaultColDef}
                                onGridReady={onGridReady}
                                pagination={true}
                                paginationPageSize={50}
                                enableRangeSelection={true}
                                enableCellContextMenu={true}
                                stopEditingWhenGridLosesFocus={true}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: "columns",
                                            labelDefault: "Columns",
                                            labelKey: "columns",
                                            iconKey: "columns",
                                            toolPanel: "agColumnsToolPanel",
                                            toolPanelParams: {
                                                suppressPivotMode: true,
                                                suppressRowGroups: true,
                                                suppressValues: true,
                                            }
                                        },
                                        {
                                            id: "filters",
                                            labelDefault: "Filters",
                                            labelKey: "filters",
                                            iconKey: "filter",
                                            toolPanel: "agFiltersToolPanel"
                                        }
                                    ]
                                }}
                                statusBar={{
                                    statusPanels: [
                                        {
                                            statusPanel: "agTotalAndFilteredRowCountComponent",
                                            align: "left"
                                        },
                                        {
                                            statusPanel: "agTotalRowCountComponent",
                                            align: "center"
                                        },
                                        { statusPanel: "agFilteredRowCountComponent" },
                                        { statusPanel: "agSelectedRowCountComponent" },
                                        { statusPanel: "agAggregationComponent" }
                                    ]
                                }} />
                        </div>
                        <br />
                        <div className="form-group">
                            <button type="submit" className="btn btn-success" onClick={saveConsignments}>Submit</button>
                            <button type="button" onClick={closeBulkUploadModal} className="btn btn-default">Cancel</button>
                        </div>
                        <br />
                        <br />
                    </div>
                </div>
            </div> 
            { (tabName.value !== "inactive") &&
                (<div className={""}>
                    <MainCounters setCounter={CounterClick} data={tabName.value == "active" ? countersActive : (tabName.value == "completed" ? countersCompleted : (tabName.value == "all" ? countersAll : countersInactive))} tabName={tabName} componentType="ptl"/>
                </div>)
            }
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                            <h5>
                                <i className="icofont icofont-vehicle-delivery-van cus-i ml-30p"></i> <span>{`${tabName?.label} - ${counter?.label}`}</span>
                            </h5>
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 mb-10p">
                                    <span className="float-right" style={{ fontSize: "13px", fontWeight: "100" }}>
                                        {/* <i className="icofont icofont-clock-time" style={{ color: "#ff0000", fontSize: "22px	" }}></i> - Transit Delays */}
                                        {/* |&nbsp;<i className="icofont icofont-social-google-map txt-danger" style={{ fontSize: "22px" }}></i> - GPS Not Available */}
                                        {/* |&nbsp; */}
                                        {/* <i className="icofont icofont-social-google-map txt-secondary" style={{ fontSize: "22px" }}></i> - GPS Data Not Adequate */}
                                        {/* |&nbsp; */}
                                        {/* <span>
                                            <i className="fa fa-tachometer darkblue" style={{ fontSize: "22px" }}></i> - Overspeeding
                                        </span>|
                                        <span>
                                            <span>&nbsp;<i className="icofont icofont-full-night txt-primary" style={{ fontSize: "22px" }}></i> - Night Driving
                                            </span>
                                            <span>|&nbsp;<i className="icofont icofont-truck-alt darkorange" style={{ fontSize: "22px" }}></i> - Loading Delay
                                            </span>
                                            {
                                                tabName?.value == "completed" || tabName?.value == "all" ?
                                                    <span>|&nbsp;<i className="icofont icofont-vehicle-delivery-van mildgreen" style={{ fontSize: "22px" }}></i> - Unloading Delay
                                                    </span> :
                                                    <></>
                                            }
                                        </span> */}
                                        {/* |&nbsp;<i className="icofont icofont-pause maroon" style={{ fontSize: "22px" }}></i> - Stoppages */}
                                        <span>
                                            {/* |&nbsp; */}
                                            {/* <i className="icofont icofont-barricade txt-danger" style={{ fontSize: "22px" }}></i> - Probable Accident */}
                                        </span>
                                    </span>

                                </div>

                                <div className={"col-xl-12 mb-10p "}>
                                    <span className="layoutbtns">
                                        <button className="float-right custom-btn white btn-danger"
                                            // onClick={this.onClickSaveGridState}
                                            style={{fontSize:"12px"}}
                                            onClick={saveGrid}
                                        >
                                            <i className="icofont icofont-save"></i> Save Grid Layout
                                        </button>
                                        <button className="float-right custom-btn white btn-info" style={{ marginRight: "10px",fontSize:"12px" }}
                                            // onClick={this.resetState}
                                            onClick={resetGrid}
                                        >
                                            <i className="icofont icofont-refresh"></i> Reset Default Layout
                                        </button>
                                        {(tabName.value === "inactive" && selectedRows.length>0) ? 
                                            <div className="float-right">
                                                <button
                                                style={{marginRight:"20px", fontSize:"12px"}}
                                                    title="Bulk Upload"
                                                    onClick={updateLrs}
                                                    className={"float-right custom-btn white btn-danger mr-2"}
                                                    type="button">
                                                    <i className="fa fa-pen"></i>&nbsp;&nbsp;&nbsp;Update LR
                                                </button>
                                            </div>                                        
                                        : ""}
                                    </span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="card-body pt-10px" >
                          
                            <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                <AgGridReact
                                    ref={agGridRef}
                                    columnDefs={columnwithDefs}
                                    rowData={rowData}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    paginationPageSize={50}
                                    onGridReady={onGridReadyConsignments}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    masterDetail={true}
                                    detailCellRendererParams={detailCellRendererParams}
                                    // frameworkComponents ={{AddDealer:AddDealerConsignments}}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }}
                                    rowSelection="multiple"  // Enable multiple row selection
                                    onSelectionChanged={onSelectionChanged}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {openMap.sliderRouteTranslate != '' ?
                <div className={"slide-r " + (openMap.sliderRouteTranslate)} style={{ overflow: "auto" }}>
                    <div className="slide-r-title">
                        <h4>
                            {(openMap.consignment_code)}
                            <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeMapModal} >X</span>
                        </h4>
                    </div>
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                            <DrawMap
                                rownode={openMap.rownode}
                                mapFor={"consignment"}
                                tolls={openMap.tolls}
                                googleroutes={openMap.googelRoutes}
                                truckno={openMap.maptruckno}
                                dealer={openMap.dealer}
                                mapinfo={openMap.mapinfo}
                                deptcode={openMap.deptcode}
                                defTransitCoords={openMap.defTransitCoords}
                                baseRouteCoords={openMap.baseRouteCoords}
                                geofence_coordinates={openMap.geofence_coordinates}
                                parking_coordinates={openMap.parking_coordinates}
                            />
                            <div className="col-xl-12 col-lg-12 n-p-0">
                                <div className="crm-numbers pb-0">
                                    <h3 className="subH">{openMap.sidebarSubHeader}</h3>
                                    <div className="col-xl-12 col-lg-12 row">
                                        <div className="col route-block">
                                            <label className="sidebar-label">Truck No</label>
                                            <div>{openMap.routeTruck.truck_no}</div>
                                        </div>
                                        <div className="col route-block">
                                            <label className="sidebar-label">Start Time</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.start_time) : "-"}</div>
                                        </div>
                                        <div className="col route-block">
                                            <label className="sidebar-label">End Time</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.end_time) : "-"}</div>
                                        </div>

                                        <div className="col route-block">
                                            <label className="sidebar-label">GPS Distance</label>
                                            <div>{(!isEmpty(openMap.mapinfo.route_details)) ? Math.round(openMap.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                : ""
            }
            <div className={"slide-r " + (bulkUploadModal.bulkPrioritySlide)} style={{ overflow: "auto" }}>
                <h3 className="subH">Bulk Upload Consignments
                    <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeBulkUploadModal} >X</span>
                </h3>

                <div className="slide-r-body" style={{ position: "relative" }}>

                    <div className="container-fluid">
                        <form method="POST" id="upform" className="theme-form">
                            <div className="col-xl-6 col-lg-6 form-group">
                                <label className="">Upload File</label>
                                <input type="file" name="uploadFile" id="bulkUploadCritical" onChange={changeFileHandler} className="form-control" required />
                            </div>
                        </form>
                        <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div className="form-group">
                                <a className="btn btn-primary" href={require('../../assets/files/PTL_Legrand_Autometrics_Consignments_Format.xlsx')} target="_blank">Sample Template</a>
                            </div>
                            <div className='form-group' style={{ marginRight: "8px" }}>
                                <div><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div>
                            </div>
                        </div>
                        <div className="ag-theme-balham mt-2" style={{ height: '58vh', width: '100%' }}>
                            <AgGridReact
                                columnDefs={columnDef}
                                rowData={modalloadData}
                                defaultColDef={defaultColDef}
                                onGridReady={onGridReady}
                                pagination={true}
                                paginationPageSize={50}
                                enableRangeSelection={true}
                                enableCellContextMenu={true}
                                stopEditingWhenGridLosesFocus={true}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: "columns",
                                            labelDefault: "Columns",
                                            labelKey: "columns",
                                            iconKey: "columns",
                                            toolPanel: "agColumnsToolPanel",
                                            toolPanelParams: {
                                                suppressPivotMode: true,
                                                suppressRowGroups: true,
                                                suppressValues: true,
                                            }
                                        },
                                        {
                                            id: "filters",
                                            labelDefault: "Filters",
                                            labelKey: "filters",
                                            iconKey: "filter",
                                            toolPanel: "agFiltersToolPanel"
                                        }
                                    ]
                                }}
                                statusBar={{
                                    statusPanels: [
                                        {
                                            statusPanel: "agTotalAndFilteredRowCountComponent",
                                            align: "left"
                                        },
                                        {
                                            statusPanel: "agTotalRowCountComponent",
                                            align: "center"
                                        },
                                        { statusPanel: "agFilteredRowCountComponent" },
                                        { statusPanel: "agSelectedRowCountComponent" },
                                        { statusPanel: "agAggregationComponent" }
                                    ]
                                }} />
                        </div>
                        <br />
                        <div className="form-group">
                            <button type="submit" className="btn btn-success" onClick={saveConsignments}>Submit</button>
                            <button type="button" onClick={closeBulkUploadModal} className="btn btn-default">Cancel</button>
                        </div>
                        <br />
                        <br />
                    </div>
                </div>
            </div>
            <div className={"slide-r " + (sliderCreateConsignmentTranslate)} style={{ overflow: "auto" }}>
					<div className="slide-r-title">
						<h4>
							Add Consignment
							<span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={onClickHideAll} >X</span>

						</h4>
					</div>
					<div className="slide-r-body" style={{ position: "relative" }}>

						<div className="row col-xl-12 col-lg-12 ml-0p n-p-0"></div>
						<div className={"row"} style={{ padding: '5px 0px', width: '100%', overflow: 'hidden', zIndex: '9999', height: "100em" }} >
							<form method="POST" className="theme-form col-xl-12 col-lg-12" onSubmit={saveConsignmentData}>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Enter Truck<span style={{color:'red'}}>*</span> </label>

									{/* <Select
										placeholder={"Select Truck"}
										closeMenuOnSelect={true}
										onChange={this.onChangeTruckItem.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="truck_no"
										value={this.state.truck_no}
										options={this.state.trucklist} /> */}
									<input
										// placeholder={"Enter Truck No"}
										type="text"
										className="form-control ml-3"
										onChange={changeHandler}
										value={formData.truck_no}
										name="truck_no"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">GR No/Consignment Code<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={changeHandler}
										value={formData.grno_consignment_code}
										name="grno_consignment_code"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Invoice No<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={changeHandler}
										value={formData.invoice_no}
										name="invoice_no"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Invoice Date<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control datetimepicker_mask ml-3"
										id="invoice_date"
										name="invoice_date"
										autoComplete='off'
									/>
								</div>
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Trip Started On<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control datetimepicker_mask ml-3"
										id="gate_out_time"
										name="gate_out_time"
										autoComplete='off'
									/>
								</div>
								
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Transit Days<span style={{color:'red'}}>*</span>  </label>
									<input
										type="number"
										className="form-control ml-3"
										onChange={changeHandler}
										value={formData.transit_days}
										name="transit_days"
										autoComplete='off'
									/>
								</div>

								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Select Plant<span style={{color:'red'}}>*</span>  </label>

									<Select
										placeholder={"Select Plant"}
										closeMenuOnSelect={true}
										// onChange={this.onChangePlantItem.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="plant_code"
										// value={this.state.plant_code}
										// options={this.state.plantlist}
                                         />
								</div>

								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Dealer Code<span style={{color:'red'}}>*</span>  </label>

									<Select
										placeholder={"Select Dealer Code"}
										closeMenuOnSelect={true}
										// onChange={this.onChangeConsigneeItem.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="consignee_code"
										// value={this.state.consignee_code}
										// options={this.state.consignees}
                                         />
								</div>
								{/* {(transporteCode)?
									<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Name </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={this.changeHandler}
										value={this.state.driver_name}
										name="driver_name"
										autoComplete='off'
									/>
								</div>
								:
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Name<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={this.changeHandler}
										value={this.state.driver_name}
										name="driver_name"
										autoComplete='off'
									/>
								</div>
								} */}
								{/* {(transporteCode)?
								<div className="col-xl-12 col-lg-12 row form-group">
								<label className="col-xl-12 col-lg-12">Driver Mobile No </label>
								<input
									type="text"
									className="form-control ml-3"
									onChange={this.changeHandler}
									value={this.state.driver_mobile_num}
									name="driver_mobile_num"
									autoComplete='off'
								/>
							</div>
								:
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Mobile No<span style={{color:'red'}}>*</span>  </label>
									<input
										type="text"
										className="form-control ml-3"
										onChange={this.changeHandler}
										value={this.state.driver_mobile_num}
										name="driver_mobile_num"
										autoComplete='off'
									/>
								</div>
								} */}
								
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Driver Mobile Operator<span style={{color:'red'}}>*</span>  </label>
									<Select
										placeholder={"Select Mobile Operator"}
										closeMenuOnSelect={true}
										// onChange={this.onChangeDriverMobileOperator.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="driverMobileOperator"
										// value={this.state.mobile_operator}
										// options={this.state.mobileOperatorData} 
										required
										/>
									
								</div>
								
								{(localStorage.getItem("user_type")=="TRANSPORTER")?"":
								<div className="col-xl-12 col-lg-12 row form-group">
									<label className="col-xl-12 col-lg-12">Transporter Name<span style={{color:'red'}}>*</span>  </label>

									<Select
										placeholder={"Select Transporter Name"}
										closeMenuOnSelect={true}
										// onChange={this.onChangeTransporterItem.bind(this)}
										className={"col-xl-12 col-lg-12 border-radius-0"}
										style={{ borderRadius: "0px" }}
										name="transporter_code"
										// value={this.state.transporter_code}
										// options={this.state.transportersdata} 
                                        />
								</div>
								}
								<div className="col-xl-12 col-lg-12 form-group">
									<button type="submit" className="btn btn-success">Submit</button>
								</div>
							</form>
						</div>
					</div>
				</div>
                <div
                    className={"slide-r " + showAddForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                        <h4>Update Consignments<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideManualUpload} >X</span></h4>
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                    <div className="col-sm-12">
                        <form onSubmit={onsubmitdata}>
                            <div className="slide-body">
                                <div className="row p-20p">
                                    <div className="form-group col-xl-12 col-lg-12"></div>{" "}
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Customer Name<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consigner_name"
                                        id="consigner_name"
                                        value={manualUploadDetails1.consigner_name}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consigner_name: e.target.value }))}
                                        required
                                    />                             
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination City<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_city"
                                        id="consignee_city"
                                        value={manualUploadDetails1.consignee_city}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_city: e.target.value }))}
                                        required
                                    /> 
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination State<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_state"
                                        id="consignee_state"
                                        value={manualUploadDetails1.consignee_state}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_state: e.target.value }))}
                                        required
                                    /> 
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Destination Pincode<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="consignee_pincode"
                                        id="consignee_pincode"
                                        value={manualUploadDetails1.consignee_pincode}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, consignee_pincode: e.target.value }))}
                                        required
                                    /> 
                                
                                </div>
                                <div className="form-group col-xl-12 col-lg-12">
                                    <label className="mb-5p">
                                    Total Weight<span style={{color:'red'}}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="total_weight"
                                        id="total_weight"
                                        value={manualUploadDetails1.total_weight}
                                        className="form-control"
                                        onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, total_weight: e.target.value }))}
                                        required
                                    />                             
                                </div>                            
                                <div className="form-group col-sm-12 mb-20p text-center">
                                    <button type="submit" className="btn btn-success">
                                    Submit
                                    </button>
                                </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    </div>
                </div> 
                <div
        className={"slide-r " + showAddForm2}
        style={{ overflow: "auto",  }}
      >
        <div className="slide-r-title">
          <h4>Update Details<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideManualUpload2} >X</span></h4>
          

        </div>
        <div className="row" style={{padding:"20px"}}>
          <div className="col-sm-12">
            <form 
            onSubmit={onClickDeliveredSubmit}
            >
              <div className="slide-body">
                <div className="row p-20p">
                  <div className="form-group col-xl-12 col-lg-12">
                    {/* <p className="mb-5p">
                      LR No: {selected_row.lr_no}
                    </p> */}
                  </div>{" "}
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Status<span style={{color:'red'}}>*</span>
                    </label>
                    <Select
                        closeMenuOnSelect={true}
                        value={form2Details.selectedStatus} 
                        onChange={(e) =>
                            setForm2Details({ ...form2Details, selectedStatus: {label:e.value, value: e.value} })
                        }
                        style={{ borderRadius: "0px" }}
                        styles={{
                            control: (provided, state) => ({
                            ...provided,
                            fontSize: "0.8rem",
                            color: "#6e707e",
                            }),
                            singleValue: (provided, state) => ({
                            ...provided,
                            fontSize: "0.9rem",
                            }),
                        }}
                        options={form2Details.event_status} 
                    />
                  </div>
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Current Location<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                        type="text"
                        name="lr_no"
                        id="lr_no"
                        value={form2Details.event_location}
                        className="form-control"
                        onChange={(e) => setForm2Details(prev => ({ ...prev, event_location: e.target.value }))}
                        required
                    />                  
                  </div>
                {ableRemark && 
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                      Remark<span style={{color:'red'}}>*</span>
                    </label>
                    <input
                        type="text"
                        name="lr_no"
                        id="lr_no"
                        value={form2Details.remark}
                        className="form-control"
                        onChange={(e) => setForm2Details(prev => ({ ...prev, remark: e.target.value }))}
                        required
                    /> 
                  </div>
                }
                  <div className="form-group col-xl-12 col-lg-12">
                    <label className="mb-5p">
                    Date Time<span style={{color:'red'}}>*</span>
                    </label>
                  <div id="datepicker1">
                        <DatePicker
                    selected={form2Details.delivered_date}
                    onChange={changeHandleDate1}
                    name="delivered_date"
                    className="datepicker-custom-ptl form-control"
                    showTimeSelect
                    timeFormat="HH:mm:ss"
                    timeIntervals={15} // Adjust this if you want different time intervals
                    timeCaption="Time"
                    dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                    // placeholderText="Date" // Equivalent to placeholder in the original
                    id="delivered_date"
                    autoComplete='off'
                    // style={{width:"100%"}}
                    required                   
                    />
                  </div>
                  
                  </div>
                  <div className="form-group col-sm-12 mb-20p text-center">
                    <button type="submit" className="btn btn-success">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div> 
                {tabName.value == 'inactive' && (
                    <div
                    className={"slide-r " + showAddForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                    <h4>Single Update LR<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideManualUpload1} >X</span></h4>
                    

                    </div>
                    <div className="row" style={{padding:"20px"}}>
                    <div className="col-sm-12">
                        <form 
                        onSubmit={onSubmitLrUpdateForm}
                        >
                        <div className="slide-body">
                            <div className="row p-20p">
                            <div className="form-group col-xl-12 col-lg-12">
                                {/* <p className="mb-5p">
                                LR No: {selected_row.lr_no}
                                </p> */}
                            </div>{" "}
                            <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                                Invoice No.<span style={{color:'red'}}>*</span>
                                </label>
                                <input
                                                        type="text"
                                                        name="lr_no"
                                                        id="lr_no"
                                                        value={manualUploadDetails.invoice_no}
                                                        className="form-control"
                                                        // onChange={(e) => setmanualUploadDetails1(prev => ({ ...prev, invoice_no: e.target.value }))}
                                                        required
                                                    /> 
                            
                            </div>
                            <div className="form-group col-xl-12 col-lg-12">
                                <label className="mb-5p">
                                LR No.<span style={{color:'red'}}>*</span>
                                </label>
                                <input
                                                        type="text"
                                                        name="lr_no"
                                                        id="lr_no"
                                                        value={manualUploadDetails.lr_no}
                                                        className="form-control"
                                                        onChange={(e) => setmanualUploadDetails(prev => ({ ...prev, lr_no: e.target.value }))}
                                                        required
                                                    /> 
                            
                            </div>                            
                            {/* <h6 style={{ color: "red", fontSize: "14px", marginTop: "2%" }}>Note: All date fields should be greater than production date</h6> */}
                            <div className="form-group col-sm-12 mb-20p text-center">
                                <button type="submit" className="btn btn-success">
                                Submit
                                </button>
                            </div>
                            </div>
                        </div>
                        </form>
                    </div>
                    </div>
                </div> 
                )} 
                {tabName.value == 'inactive' && (
                    <div
                    className={"slide-r " + showUpdateLrForm}
                    style={{ overflow: "auto",  }}
                >
                    <div className="slide-r-title">
                        <h4>Update LR<span className="float-right closebtn" style={{ marginRight: "25px"}} onClick={onClickHideLrUpdateForm} >X</span></h4>                  
                    </div>
                    <div className="row" style={{padding:"20px"}}>
                        <div className="col-sm-12">
                            <form onSubmit={onSubmitLrUpdateForm}>
                                <div className="slide-body">
                                    <div className="row p-20p">
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            Invoice No.<span style={{color:'red'}}>*</span>
                                            </label>
                                            <Select placeholder={"All"} closeMenuOnSelect={false}
                                                value={selectedInvoicetoUpdateLr}
                                                isMulti={true}
                                                className="border-radius-0"
                                                // onChange={e => setInvoiceSelected(e)}
                                                style={{ borderRadius: "0px" }}
                                                options={selectedInvoicetoUpdateLr}
                                                required 
                                            />
                                        </div>
                                        <div className="form-group col-xl-12 col-lg-12">
                                            <label className="mb-5p">
                                            LR No.<span style={{color:'red'}}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="lr_no"
                                                value={updatelrNo}
                                                className="form-control"
                                                onChange={(e) => setUpdateLrNo(e.target.value)}
                                                required
                                            />                        
                                        </div>
                                        <div className="form-group col-sm-12 mb-20p text-center">
                                            <button type="submit" className="btn btn-success">Submit</button>
                                            <button type="button" onClick={cancelUpdateLrNo} className="btn btn-default">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div> 
                )} 

                <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }} onClick={onClickHideAll}>

                </div>
                <div className={"dataLoadpage " + (loadshow)}></div>
                <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
            </div >
    );
}

export default PTLConsignments;

function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}
function secondsToString(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays + " days " + numhours + " hours " + numminutes + " minutes ";
}

function secondsToDays(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays;
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
} 
function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
		// console.log(date1,date2);
		var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
		date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
		var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
		date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
		// console.log(date1,date2);
		var date1Number = monthToComparableNumber(date1);
		var date2Number = monthToComparableNumber(date2);
		// console.log(date1Number,date2Number);
		if (date1Number === null && date2Number === null) {
			return 0;
		}
		if (date1Number === null) {
			return -1;
		}
		if (date2Number === null) {
			return 1;
		}
		return date1Number - date2Number;
	}
}
function getMonthNumber(monthName) {
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
	];
	var monthNum = months.indexOf(monthName) + 1;
	if (monthNum < 10) {
		monthNum = "0" + monthNum.toString();
	}
	return monthNum;
}
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	//console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
